// src/components/molecules/ChipSelect.tsx
import { autoUpdate, flip, offset, shift, size, useFloating } from "@floating-ui/react";
import _10 from "lodash/fp.js";
import { useCallback as useCallback5, useEffect as useEffect4, useMemo as useMemo2, useState as useState4, useTransition } from "react";

// src/components/atoms/Chip.tsx
import _4 from "lodash/fp.js";
import { useCallback, useMemo } from "react";
import { cx as cx2 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_components_atoms_Chip.module.css
var src_components_atoms_Chip_default = { "label": "pkit-9HB4Qa-label", "button": "pkit-9HB4Qa-button", "chip": "pkit-9HB4Qa-chip" };

// src/components/atoms/Icon.tsx
import _3 from "lodash/fp.js";

// src/constants/exposedClassNames.tsx
var KIT_BUTTON_CLASSNAME = "kit-button";
var KIT_BUTTONSLIST_CLASSNAME = "kit-buttonslist";
var KIT_CIRCULARPROGRESSBAR_CLASSNAME = "kit-circularprogressbar";
var KIT_DIVIDER_CLASSNAME = "kit-divider";
var KIT_ICON_CLASSNAME = "kit-icon";
var KIT_TAB_CLASSNAME = "kit-tab";
var KIT_TABS_CLASSNAME = "kit-tabs";
var KIT_PLAYER_CLASSNAME = "kit-player";
var KIT_PLAYER_AUDIO_CLASSNAME = "kit-player-audio";
var KIT_PLAYER_VIDEO_CLASSNAME = "kit-player-video";
var KIT_MODAL_CLASSNAME = "kit-modal";
var KIT_SWITCHBUTTON_CLASSNAME = "kit-switchbutton";
var KIT_TOOLTIP_CLASSNAME = "kit-tooltip";

// src/components/style/Icons.tsx
import { wrap } from "@lls/utils";
import _ from "lodash/fp.js";
import { useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
var svgAttrsInCache = /* @__PURE__ */ new Map();
var ssrSvgAttrsInCache = /* @__PURE__ */ new Map();
var ssrFetchAndCache = (basename) => {
  let prom = ssrSvgAttrsInCache.get(basename);
  if (prom) {
    return prom;
  }
  if (!prom) {
    prom = wrap(
      new Promise((resolve, reject) => {
        const path = `/assets/svgIcons/${basename}`;
        try {
          import("axios").then((m) => m.default.get || _.get("get", m)).then((get) => {
            return get(`${process.env.SSR_SYNC_ICONES_URL}${path}`).then((res) => res.data);
          }).then((xml) => {
            var _a;
            const $ = globalThis.cheerio.load(xml);
            const svg = $("svg");
            return ((_a = svg[0]) == null ? void 0 : _a.type) === "tag" ? { props: Object.assign({}, svg[0].attribs), content: svg.html() || "" } : { props: {}, content: "" };
          }).then(resolve).catch(reject);
        } catch (e) {
          console.log("failed to load svgIcon", e, path);
          return reject(e);
        }
      })
    );
    ssrSvgAttrsInCache.set(basename, prom);
  }
  return prom;
};
var fetchAndCache = (basename) => {
  let prom = svgAttrsInCache.get(basename);
  if (!prom) {
    prom = new Promise((resolve, reject) => {
      const path = `/assets/svgIcons/${basename}`;
      try {
        fetch(path).then(async (res) => {
          const node = document.createElement("div");
          const txt = await res.text();
          node.innerHTML = txt;
          const svg = node.querySelector("svg");
          const svgProps = {};
          for (let i = 0; i < svg.attributes.length; ++i) {
            const attr = svg.attributes.item(i);
            const attrName = attr.name;
            svgProps[attrName] = attr.value;
          }
          return { props: svgProps, content: svg.innerHTML };
        }).then(resolve).catch(reject);
      } catch (e) {
        console.log("failed to load svgIcon", e, path);
        return reject(e);
      }
    });
    svgAttrsInCache.set(basename, prom);
  }
  return prom;
};
var makeIcon = (basename) => {
  return (props) => {
    let [svgAttrs, setSvgAttrs] = useState();
    if (process.env.SSR_SYNC_ICONES_URL && typeof globalThis !== "undefined" && !!globalThis.cheerio) {
      svgAttrs = ssrFetchAndCache(basename).read();
    } else {
      useEffect(() => {
        fetchAndCache(basename).then(setSvgAttrs);
      }, [basename]);
    }
    return /* @__PURE__ */ jsx(
      "svg",
      {
        suppressHydrationWarning: true,
        width: "18",
        height: "22",
        viewBox: "0 0 18 22",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgAttrs == null ? void 0 : svgAttrs.props,
        ...props,
        dangerouslySetInnerHTML: { __html: (svgAttrs == null ? void 0 : svgAttrs.content) ?? "" }
      }
    );
  };
};
var ICONS = {
  ArrowRightToLineIcon: makeIcon("ArrowRightToLineIcon.svg"),
  ArrowDownToLineIcon: makeIcon("ArrowDownToLineIcon.svg"),
  ArrowDropDownIcon: makeIcon("ArrowDropDown.svg"),
  ArrowLeftFromLineIcon: makeIcon("ArrowLeftFromLineIcon.svg"),
  ArrowMoveIcon: makeIcon("ArrowMoveIcon.svg"),
  HorizontalDotsIcon: makeIcon("HorizontalDotsIcon.svg"),
  VerticalDotsIcon: makeIcon("VerticalDotsIcon.svg"),
  DragIcon: makeIcon("DragIcon.svg"),
  ArrowTopLeftAndBottomRightIcon: makeIcon("ArrowTopLeftAndBottomRightIcon.svg"),
  ArrowTopLeftAndBottomRightInvertedIcon: makeIcon("ArrowTopLeftAndBottomRightInvertedIcon.svg"),
  CheckMarkIcon: makeIcon("CheckMarkIcon.svg"),
  AddFileIcon: makeIcon("AddFileIcon.svg"),
  EyeSlashIcon: makeIcon("EyeSlashIcon.svg"),
  AddFolderIcon: makeIcon("AddFolderIcon.svg"),
  TwoGearsIcon: makeIcon("TwoGearsIcon.svg"),
  GearFilledIcon: makeIcon("GearFilledIcon.svg"),
  GearIcon: makeIcon("GearIcon.svg"),
  GoBackward10Icon: makeIcon("GoBackward10Icon.svg"),
  GoBackwardIcon: makeIcon("GoBackwardIcon.svg"),
  GoForward10Icon: makeIcon("GoForward10Icon.svg"),
  HeartFilledIcon: makeIcon("HeartFilledIcon.svg"),
  HeartIcon: makeIcon("HeartIcon.svg"),
  UploadCloudIcon: makeIcon("UploadCloudIcon.svg"),
  InfoCircleFilledIcon: makeIcon("InfoCircleFilledIcon.svg"),
  InfoCircleIcon: makeIcon("InfoCircleIcon.svg"),
  LinkIcon: makeIcon("LinkIcon.svg"),
  MapIcon: makeIcon("MapIcon.svg"),
  MicFilledIcon: makeIcon("MicFilledIcon.svg"),
  MicIcon: makeIcon("MicIcon.svg"),
  MoonIcon: makeIcon("MoonIcon.svg"),
  PaperPlaneFilledIcon: makeIcon("PaperPlaneFilledIcon.svg"),
  PaperPlaneIcon: makeIcon("PaperPlaneIcon.svg"),
  PauseIcon: makeIcon("PauseIcon.svg"),
  PlayFilledIcon: makeIcon("PlayFilledIcon.svg"),
  PlayIcon: makeIcon("PlayIcon.svg"),
  SpeakerSlashIcon: makeIcon("SpeakerSlashIcon.svg"),
  SpeakerSlashFilledIcon: makeIcon("SpeakerSlashFilledIcon.svg"),
  SpeakerWaveFilledIcon: makeIcon("SpeakerWaveFilledIcon.svg"),
  SpeakerWaveIcon: makeIcon("SpeakerWaveIcon.svg"),
  SquareAndPencilIcon: makeIcon("SquareAndPencilIcon.svg"),
  ArrowReloadIcon: makeIcon("ArrowReloadIcon.svg"),
  SquareOnSquareFilledIcon: makeIcon("SquareOnSquareFilledIcon.svg"),
  SquareOnSquareIcon: makeIcon("SquareOnSquareIcon.svg"),
  StarFilledIcon: makeIcon("StarFilledIcon.svg"),
  StarIcon: makeIcon("StarIcon.svg"),
  SunMaxIcon: makeIcon("SunMaxIcon.svg"),
  TextFormatSizeIcon: makeIcon("TextFormatSizeIcon.svg"),
  TrashFilledIcon: makeIcon("TrashFilledIcon.svg"),
  TrashIcon: makeIcon("TrashIcon.svg"),
  VideoFilledIcon: makeIcon("VideoFilledIcon.svg"),
  VideoIcon: makeIcon("VideoIcon.svg"),
  WarningFilledIcon: makeIcon("WarningFilledIcon.svg"),
  WarningIcon: makeIcon("WarningIcon.svg"),
  CancelCircleFilledIcon: makeIcon("CancelCircleFilledIcon.svg"),
  CancelCircleIcon: makeIcon("CancelCircleIcon.svg"),
  CancelIcon: makeIcon("CancelIcon.svg"),
  ArrowDownIcon: makeIcon("ArrowDownIcon.svg"),
  ArrowLeftIcon: makeIcon("ArrowLeftIcon.svg"),
  ArrowRightIcon: makeIcon("ArrowRightIcon.svg"),
  ArrowUpIcon: makeIcon("ArrowUpIcon.svg"),
  CarretLeftIcon: makeIcon("CarretLeftIcon.svg"),
  CarretRightIcon: makeIcon("CarretRightIcon.svg"),
  CarretUpIcon: makeIcon("CarretUpIcon.svg"),
  CarretDownIcon: makeIcon("CarretDownIcon.svg"),
  ChevronDownIcon: makeIcon("ChevronDownIcon.svg"),
  ChevronLeftCircleFilledIcon: makeIcon("ChevronLeftCircleFilledIcon.svg"),
  ChevronLeftIcon: makeIcon("ChevronLeftIcon.svg"),
  ChevronRightCircleFilledIcon: makeIcon("ChevronRightCircleFilledIcon.svg"),
  ChevronRightIcon: makeIcon("ChevronRightIcon.svg"),
  ChevronUpIcon: makeIcon("ChevronUpIcon.svg"),
  MagnificentGlassIcon: makeIcon("MagnificentGlassIcon.svg"),
  MinusCircleFilledIcon: makeIcon("MinusCircleFilledIcon.svg"),
  MinusCircleIcon: makeIcon("MinusCircleIcon.svg"),
  MinusIcon: makeIcon("MinusIcon.svg"),
  PlusCircleFilledIcon: makeIcon("PlusCircleFilledIcon.svg"),
  PlusCircleIcon: makeIcon("PlusCircleIcon.svg"),
  PlusIcon: makeIcon("PlusIcon.svg"),
  KeyboardIcon: makeIcon("KeyboardIcon.svg"),
  KeyboardFilledIcon: makeIcon("KeyboardFilledIcon.svg"),
  EyeFilledIcon: makeIcon("EyeFilledIcon.svg"),
  EyeIcon: makeIcon("EyeIcon.svg"),
  GroupFilledIcon: makeIcon("GroupFilledIcon.svg"),
  GroupIcon: makeIcon("GroupIcon.svg"),
  PersonFilledIcon: makeIcon("PersonFilledIcon.svg"),
  PersonIcon: makeIcon("PersonIcon.svg"),
  GraduationCapFilledIcon: makeIcon("GraduationCapFilledIcon.svg"),
  GraduationCapIcon: makeIcon("GraduationCapIcon.svg"),
  PinFilledIcon: makeIcon("PinFilledIcon.svg"),
  PinIcon: makeIcon("PinIcon.svg"),
  CloverFilledIcon: makeIcon("CloverFilledIcon.svg"),
  CloverIcon: makeIcon("CloverIcon.svg"),
  TimerIcon: makeIcon("TimerIcon.svg"),
  BoldIcon: makeIcon("BoldIcon.svg"),
  FunctionIcon: makeIcon("FunctionIcon.svg"),
  ItalicIcon: makeIcon("ItalicIcon.svg"),
  StrikeThroughIcon: makeIcon("StrikeThroughIcon.svg"),
  SumIcon: makeIcon("SumIcon.svg"),
  UnderlineIcon: makeIcon("UnderlineIcon.svg"),
  ScrollIcon: makeIcon("ScrollIcon.svg"),
  AirplaneDepartureIcon: makeIcon("AirplaneDepartureIcon.svg"),
  NextEraIcon: makeIcon("NextEraIcon.svg"),
  PreviousEraIcon: makeIcon("PreviousEraIcon.svg"),
  ForwardAppIcon: makeIcon("ForwardAppIcon.svg"),
  ShareTurnUpRightFilledIcon: makeIcon("ShareTurnUpRightFilledIcon.svg"),
  ShareTurnUpRightIcon: makeIcon("ShareTurnUpRightIcon.svg"),
  DocTextFilledIcon: makeIcon("DocTextFilledIcon.svg"),
  DocTextIcon: makeIcon("DocTextIcon.svg"),
  TextFormatSizeLargerIcon: makeIcon("TextFormatSizeLargerIcon.svg"),
  TextFormatSizeSmallerIcon: makeIcon("TextFormatSizeSmallerIcon.svg"),
  EarthIcon: makeIcon("EarthIcon.svg"),
  HumanInCircleIcon: makeIcon("HumanInCircleIcon.svg"),
  DoubleChevronRightIcon: makeIcon("DoubleChevronRightIcon.svg"),
  CarretUpDown: makeIcon("CarretUpDown.svg"),
  ListBulletIcon: makeIcon("ListBulletIcon.svg"),
  ListNumberIcon: makeIcon("ListNumberIcon.svg"),
  TextFormatSubtitleIcon: makeIcon("TextFormatSubtitleIcon.svg"),
  TextFormatTitleIcon: makeIcon("TextFormatTitleIcon.svg"),
  TextFormatSupIcon: makeIcon("TextFormatSupIcon.svg"),
  TextFormatSubIcon: makeIcon("TextFormatSubIcon.svg"),
  PictureIcon: makeIcon("PictureIcon.svg"),
  PlayCircleIcon: makeIcon("PlayCircleIcon.svg"),
  PlayRectangleIcon: makeIcon("PlayRectangleIcon.svg"),
  UndoIcon: makeIcon("UndoIcon.svg"),
  ThicknessThinIcon: makeIcon("ThicknessThinIcon.svg"),
  ThicknessLightIcon: makeIcon("ThicknessLightIcon.svg"),
  ThicknessRegularIcon: makeIcon("ThicknessRegularIcon.svg"),
  ThicknessBoldIcon: makeIcon("ThicknessBoldIcon.svg"),
  ThicknessExtraboldIcon: makeIcon("ThicknessExtraboldIcon.svg"),
  ThicknessIcon: makeIcon("ThicknessIcon.svg"),
  TextWeightIcon: makeIcon("TextWeightIcon.svg"),
  TextIcon: makeIcon("TextIcon.svg"),
  SquareIcon: makeIcon("SquareIcon.svg"),
  SquareFilledIcon: makeIcon("SquareFilledIcon.svg"),
  LineIcon: makeIcon("LineIcon.svg"),
  ArrowIcon: makeIcon("ArrowIcon.svg"),
  PaintbrushPointedIcon: makeIcon("PaintbrushPointedIcon.svg"),
  PaintbrushPointedFilledIcon: makeIcon("PaintbrushPointedFilledIcon.svg"),
  HighlightIcon: makeIcon("HighlightIcon.svg"),
  FreeShapeIcon: makeIcon("FreeShapeIcon.svg"),
  DeleteIcon: makeIcon("DeleteIcon.svg"),
  CursorIcon: makeIcon("CursorIcon.svg"),
  CommentIcon: makeIcon("CommentIcon.svg"),
  CircleIcon: makeIcon("CircleIcon.svg"),
  CircleFilledIcon: makeIcon("CircleFilledIcon.svg"),
  WidthIcon: makeIcon("WidthIcon.svg"),
  ArrowBackIcon: makeIcon("ArrowBackIcon.svg"),
  ArrowForwardIcon: makeIcon("ArrowForwardIcon.svg"),
  NoColorIcon: makeIcon("NoColorIcon.svg"),
  ColorOutlineWhiteIcon: makeIcon("ColorOutlineWhiteIcon.svg"),
  LineDashedIcon: makeIcon("LineDashedIcon.svg"),
  LineDottedIcon: makeIcon("LineDottedIcon.svg"),
  LineNormalIcon: makeIcon("LineNormalIcon.svg"),
  OpacityIcon: makeIcon("OpacityIcon.svg"),
  Number1CircleFilledIcon: makeIcon("Number1CircleFilledIcon.svg"),
  Number2CircleFilledIcon: makeIcon("Number2CircleFilledIcon.svg"),
  PadLandscapesIcon: makeIcon("PadLandscapesIcon.svg"),
  QuestionMarkCircleIcon: makeIcon("QuestionMarkCircleIcon.svg"),
  GiftIcon: makeIcon("GiftIcon.svg"),
  GiftFilledIcon: makeIcon("GiftFilledIcon.svg"),
  HandtapIcon: makeIcon("HandtapIcon.svg"),
  HelpIcon: makeIcon("HelpIcon.svg"),
  ArrowUTurnDownCircleIcon: makeIcon("ArrowUTurnDownCircleIcon.svg"),
  ArrowUTurnDownCircleFilledIcon: makeIcon("ArrowUTurnDownCircleFilledIcon.svg"),
  DocIcon: makeIcon("DocIcon.svg"),
  DocFilledIcon: makeIcon("DocFilledIcon.svg"),
  SidebarLeftIcon: makeIcon("SidebarLeftIcon.svg"),
  BellIcon: makeIcon("BellIcon.svg"),
  BellFilledIcon: makeIcon("BellFilledIcon.svg"),
  ScreenIcon: makeIcon("ScreenIcon.svg"),
  MathToolsIcon: makeIcon("MathToolsIcon.svg"),
  HeadphoneIcon: makeIcon("HeadphoneIcon.svg"),
  HeadphoneFilledIcon: makeIcon("HeadphoneFilledIcon.svg"),
  IdeaIcon: makeIcon("IdeaIcon.svg"),
  IdeaFilledIcon: makeIcon("IdeaFilledIcon.svg"),
  ChecklistIcon: makeIcon("ChecklistIcon.svg"),
  EditIcon: makeIcon("EditIcon.svg"),
  BookIcon: makeIcon("BookIcon.svg"),
  BookClosedIcon: makeIcon("BookClosedIcon.svg"),
  QuizIcon: makeIcon("QuizIcon.svg"),
  BacIcon: makeIcon("BacIcon.svg"),
  MindIcon: makeIcon("MindIcon.svg"),
  DiscussIcon: makeIcon("DiscussIcon.svg"),
  VisionIcon: makeIcon("VisionIcon.svg"),
  VisionEyeIcon: makeIcon("VisionEyeIcon.svg"),
  PairIcon: makeIcon("PairIcon.svg"),
  PairFilledIcon: makeIcon("PairFilledIcon.svg"),
  MegaphoneIcon: makeIcon("MegaphoneIcon.svg"),
  ChatIcon: makeIcon("ChatIcon.svg"),
  MouseIcon: makeIcon("MouseIcon.svg"),
  ClickIcon: makeIcon("ClickIcon.svg"),
  MediationIcon: makeIcon("MediationIcon.svg"),
  SandClockIcon: makeIcon("SandClockIcon.svg"),
  MicrophoneIcon: makeIcon("MicrophoneIcon.svg"),
  ClapIcon: makeIcon("ClapIcon.svg"),
  VideoGameIcon: makeIcon("VideoGameIcon.svg"),
  DiceIcon: makeIcon("DiceIcon.svg"),
  TPIcon: makeIcon("TPIcon.svg"),
  WBIcon: makeIcon("WBIcon.svg"),
  CECRIcon: makeIcon("CECRIcon.svg"),
  IdiomIcon: makeIcon("IdiomIcon.svg"),
  EchoIcon: makeIcon("EchoIcon.svg"),
  TheaterIcon: makeIcon("TheaterIcon.svg"),
  TheaterFilledIcon: makeIcon("TheaterFilledIcon.svg"),
  AtIcon: makeIcon("AtIcon.svg"),
  KeydataIcon: makeIcon("KeydataIcon.svg"),
  MusicIcon: makeIcon("MusicIcon.svg"),
  LeafIcon: makeIcon("LeafIcon.svg"),
  ThumbIcon: makeIcon("ThumbIcon.svg"),
  ThumbFilledIcon: makeIcon("ThumbFilledIcon.svg"),
  ResizeIcon: makeIcon("ResizeIcon.svg"),
  RotateLeftIcon: makeIcon("RotateLeftIcon.svg"),
  RotateRightIcon: makeIcon("RotateRightIcon.svg"),
  ArrowShareTurnUpRightIcon: makeIcon("ArrowShareTurnUpRightIcon.svg"),
  AccessibilityIcon: makeIcon("AccessibilityIcon.svg"),
  LockIcon: makeIcon("LockIcon.svg"),
  BoltFilledIcon: makeIcon("BoltFilledIcon.svg"),
  XMarkShieldFilledIcon: makeIcon("XMarkShieldFilledIcon.svg"),
  ExclamationMarkShieldFilledIcon: makeIcon("ExclamationMarkShieldFilledIcon.svg"),
  ExclamationFilledIcon: makeIcon("ExclamationFilledIcon.svg"),
  ParagraphIcon: makeIcon("ParagraphIcon.svg"),
  WavyUnderlineIcon: makeIcon("WavyUnderlineIcon.svg"),
  QcmIcon: makeIcon("QcmIcon.svg"),
  QcuIcon: makeIcon("QcuIcon.svg"),
  PythonIcon: makeIcon("PythonIcon.svg"),
  QuoteIcon: makeIcon("QuoteIcon.svg"),
  AppreciationIcon: makeIcon("AppreciationIcon.svg"),
  CopyrightIcon: makeIcon("CopyrightIcon.svg"),
  PremiumIcon: makeIcon("PremiumIcon.svg"),
  LockFilled: makeIcon("LockFilled.svg"),
  AccountIcon: makeIcon("AccountIcon.svg"),
  AccountFilledIcon: makeIcon("AccountFilledIcon.svg"),
  FilterIcon: makeIcon("FilterIcon.svg"),
  SocketIcon: makeIcon("SocketIcon.svg"),
  DisplayIcon: makeIcon("DisplayIcon.svg"),
  SummaryFoldIcon: makeIcon("SummaryFoldIcon.svg"),
  SummaryUnfoldIcon: makeIcon("SummaryUnfoldIcon.svg"),
  ShareIcon: makeIcon("ShareIcon.svg"),
  WindowsIcon: makeIcon("WindowsIcon.svg"),
  LinuxIcon: makeIcon("LinuxIcon.svg"),
  AppleIcon: makeIcon("AppleIcon.svg"),
  AndroidIcon: makeIcon("AndroidIcon.svg"),
  EcoleDirecteIcon: makeIcon("EcoleDirecteIcon.svg"),
  BooksIcon: makeIcon("BooksIcon.svg"),
  TwitterIcon: makeIcon("TwitterIcon.svg"),
  YoutubeIcon: makeIcon("YoutubeIcon.svg"),
  LinkedinIcon: makeIcon("LinkedinIcon.svg"),
  FacebookIcon: makeIcon("FacebookIcon.svg"),
  InstagramIcon: makeIcon("InstagramIcon.svg"),
  TikTokIcon: makeIcon("TikTokIcon.svg"),
  XIcon: makeIcon("XIcon.svg"),
  BubbleIcon: makeIcon("BubbleIcon.svg"),
  WifiSlashIcon: makeIcon("WifiSlashIcon.svg"),
  WifiIcon: makeIcon("WifiIcon.svg"),
  ChartIcon: makeIcon("ChartIcon.svg"),
  CircleCheckmark: makeIcon("CircleCheckmark.svg"),
  Unpublished: makeIcon("UnpublishedIcon.svg"),
  Page: makeIcon("Page.svg"),
  Clock: makeIcon("Clock.svg"),
  EntIcon: makeIcon("EntIcon.svg"),
  BooksFilledIcon: makeIcon("BooksFilledIcon.svg"),
  PersonCheckmark: makeIcon("PersonCheckmark.svg"),
  CheckMarkFilled: makeIcon("CheckMarkFilled.svg"),
  Logout: makeIcon("Logout.svg"),
  TeacherBook: makeIcon("TeacherBook.svg"),
  Chronoquiz: makeIcon("Chronoquiz.svg"),
  Atrium: makeIcon("Atrium.svg"),
  Pronote: makeIcon("Pronote.svg"),
  Envelope: makeIcon("Envelope.svg"),
  Phone: makeIcon("Phone.svg"),
  BubbleEmpty: makeIcon("BubbleEmpty.svg"),
  Web: makeIcon("Web.svg"),
  Print: makeIcon("Print.svg"),
  Fullscreen: makeIcon("Fullscreen.svg"),
  Home: makeIcon("Home.svg"),
  Dashboard: makeIcon("Dashboard.svg"),
  Camera: makeIcon("Camera.svg"),
  BackwardIcon: makeIcon("BackwardIcon.svg"),
  ForwardIcon: makeIcon("ForwardIcon.svg"),
  CheckmarkBubble: makeIcon("CheckmarkBubble.svg"),
  CheckmarkBubbleFilled: makeIcon("CheckmarkBubbleFilled.svg"),
  ThreeLines: makeIcon("ThreeLines.svg"),
  ExclamationMarkCircleFilled: makeIcon("ExclamationMarkCircleFilled.svg"),
  OptionalFilled: makeIcon("OptionalFilled.svg"),
  MandatoryFilled: makeIcon("MandatoryFilled.svg"),
  PartnershipFilled: makeIcon("PartnershipFilled.svg"),
  LockOpenFilled: makeIcon("LockOpenFilled.svg"),
  Resource: makeIcon("Resource.svg"),
  CheckmarkShieldFilled: makeIcon("CheckmarkShieldFilledIcon.svg"),
  QuestionMarkCircleFilled: makeIcon("QuestionMarkCircleFilledIcon.svg"),
  LinkOut: makeIcon("LinkOut.svg"),
  CartIcon: makeIcon("Cart.svg"),
  FitScreenIcon: makeIcon("FitScreen.svg"),
  FocusCursorIcon: makeIcon("FocusCursor.svg"),
  FocusCursorOffIcon: makeIcon("FocusCursorOff.svg"),
  ProjectionIcon: makeIcon("Projection.svg"),
  ViewColumnIcon: makeIcon("ViewColumn.svg"),
  DeployedCodeIcon: makeIcon("DeployedCode.svg"),
  AISparksIcon: makeIcon("AISparksIcon.svg"),
  PrinterIcon: makeIcon("PrinterIcon.svg"),
  WordIcon: makeIcon("WordIcon.svg"),
  MoodleIcon: makeIcon("MoodleIcon.svg"),
  LaptopMacIcon: makeIcon("LaptopMacIcon.svg"),
  CheckboxIcon: makeIcon("CheckboxIcon.svg"),
  AutoRenewIcon: makeIcon("AutoRenewIcon.svg"),
  SchoolbagIcon: makeIcon("Schoolbag.svg"),
  ExploreFilledIcon: makeIcon("ExploreFilledIcon.svg"),
  ImportContactFilledIcon: makeIcon("ImportContactFilledIcon.svg"),
  RefreshIcon: makeIcon("RefreshIcon.svg"),
  GroupAdd: makeIcon("GroupAdd.svg"),
  MagicExchange: makeIcon("MagicExchange.svg"),
  History: makeIcon("History.svg"),
  TouchAppFillIcon: makeIcon("TouchAppFillIcon.svg"),
  ArrowUpCircleFilled: makeIcon("ArrowUpCircleFilled.svg"),
  ArrowRightCircleFilled: makeIcon("ArrowRightCircleFilled.svg"),
  Explore: makeIcon("Explore.svg"),
  OutboxFill: makeIcon("OutboxFill.svg"),
  Turtle: makeIcon("Turtle.svg"),
  ForumIcon: makeIcon("ForumIcon.svg"),
  ExchangeIcon: makeIcon("ExchangeIcon.svg"),
  ToolsIcon: makeIcon("ToolsIcon.svg"),
  AddNoteIcon: makeIcon("AddNoteIcon.svg"),
  DownloadIcon: makeIcon("DownloadIcon.svg"),
  DrawIcon: makeIcon("DrawIcon.svg"),
  EditFilledIcon: makeIcon("EditFilledIcon.svg"),
  GraphicEqIcon: makeIcon("GraphicEqIcon.svg"),
  ConfettiIcon: makeIcon("ConfettiIcon.svg"),
  AudioFilledIcon: makeIcon("AudioFilledIcon.svg"),
  ExternalLinkIcon: makeIcon("ExternalLinkIcon.svg"),
  BookFilledIcon: makeIcon("BookFilledIcon.svg"),
  BookinouIcon: makeIcon("BookinouIcon.svg"),
  ImageFilledIcon: makeIcon("ImageFilledIcon.svg"),
  AnimationIcon: makeIcon("AnimationIcon.svg"),
  PlayReactangleFilledIcon: makeIcon("PlayReactangleFilledIcon.svg"),
  EditFileFilledIcon: makeIcon("EditFileFilledIcon.svg"),
  ToolsFilledIcon: makeIcon("ToolsFilledIcon.svg"),
  FullscreenIcon: makeIcon("FullscreenIcon.svg"),
  RepeatIcon: makeIcon("RepeatIcon.svg"),
  RepeatOffIcon: makeIcon("RepeatOffIcon.svg"),
  FullScreenExitIcon: makeIcon("FullScreenExitIcon.svg"),
  RecordVoiceOverFilledIcon: makeIcon("RecordVoiceOverFilledIcon.svg"),
  FullscreenNewIcon: makeIcon("FullscreenNewIcon.svg"),
  VolumeIcon: makeIcon("VolumeIcon.svg"),
  VolumeMuteIcon: makeIcon("VolumeMuteIcon.svg"),
  VolumeDownIcon: makeIcon("VolumeDownIcon.svg"),
  SellFilledIcon: makeIcon("SellFilledIcon.svg"),
  RemoveIcon: makeIcon("RemoveIcon.svg"),
  HighlightedAreasIcon: makeIcon("HighlightedAreasIcon.svg"),
  StudentIcon: makeIcon("StudentIcon.svg"),
  BackgroundReplaceIcon: makeIcon("BackgroundReplaceIcon.svg"),
  GroupFillIcon: makeIcon("GroupFillIcon.svg"),
  PhoneInTalkIcon: makeIcon("PhoneInTalkIcon.svg"),
  MailFillIcon: makeIcon("MailFillIcon.svg"),
  ExpandMoreIcon: makeIcon("ExpandMoreIcon.svg"),
  ExpandLessIcon: makeIcon("ExpandLessIcon.svg"),
  BorderedListBullet: makeIcon("BorderedListBullet.svg"),
  ZoomInIcon: makeIcon("ZoomInIcon.svg"),
  ZoomOutIcon: makeIcon("ZoomOutIcon.svg"),
  SignPostFiledIcon: makeIcon("SignPostFiledIcon.svg"),
  TeamIcon: makeIcon("TeamIcon.svg"),
  CalendarIcon: makeIcon("CalendarIcon.svg"),
  TagIcon: makeIcon("TagIcon.svg"),
  InfoIcon: makeIcon("InfoIcon.svg"),
  BarCodeIcon: makeIcon("BarCode.svg"),
  LocalLibraryIcon: makeIcon("LocalLibraryIcon.svg"),
  SaveFillIcon: makeIcon("SaveFill.svg"),
  SaveAsIcon: makeIcon("SaveAs.svg"),
  AudioWave: makeIcon("AudioWave.svg"),
  TextFields: makeIcon("TextFieldsIcon.svg")
};
var MELI = {
  Activity: makeIcon("Meli_activity.svg"),
  Correction: makeIcon("Meli_correction.svg"),
  Default: makeIcon("Meli_default.svg"),
  Display: makeIcon("Meli_display.svg"),
  Listen: makeIcon("Meli_listen.svg"),
  Reading: makeIcon("Meli_reading.svg"),
  Stars: makeIcon("Meli_stars.svg"),
  Update: makeIcon("Meli_update.svg"),
  Pen: makeIcon("Meli_pen.svg"),
  Video: makeIcon("Meli_video.svg"),
  Image: makeIcon("Meli_image.svg"),
  Animation: makeIcon("Meli_animation.svg")
};

// src/constants/icon.tsx
import _2 from "lodash/fp.js";
var ICONS_MAP = _2.flow(
  _2.toPairs,
  _2.map(([name, component]) => [_2.flow(_2.toLower, _2.replace(/icon$/, ""))(name), component]),
  _2.fromPairs
)(ICONS);

// src/constants/index.tsx
var KIT_CLASSNAME_THEME_PREFIX = "lls-kit-theme-";
var KIT_CLASSNAME_LIGHT_THEME = `${KIT_CLASSNAME_THEME_PREFIX}light`;
var KIT_CLASSNAME_DARK_THEME = `${KIT_CLASSNAME_THEME_PREFIX}dark`;
var KIT_CLASSNAME_FREE_LIGHT_THEME = `${KIT_CLASSNAME_THEME_PREFIX}free-light`;
var KIT_CLASSNAME_FREE_DARK_THEME = `${KIT_CLASSNAME_THEME_PREFIX}free-dark`;
var KIT_CLASSNAME_INVERTED_THEME = "lls-kit-inverted-theme";
var KIT_PORTAL_ROOT_CLASSNAME = "lls-kit-portal-root";
var KIT_PORTAL_CLASSNAME = "lls-kit-portal";
var KEY_CODE = {
  ESCAPE: 27
};
var ELEMENT_POSITION = {
  top: "top",
  right: "right",
  bottom: "bottom",
  left: "left"
};

// src/constants/theme.tsx
var THEMES = {
  BLACK_THEME: "black",
  WHITE_THEME: "white",
  GRAY_THEME: "gray",
  RED_THEME: "red",
  RED_LIGHT_THEME: "light-red",
  GREEN_THEME: "green",
  GREEN_LIGHT_THEME: "light-green",
  ORANGE_THEME: "orange",
  ORANGE_LIGHT_THEME: "light-orange",
  BLUE_THEME: "blue",
  BLUE_LIGHT_THEME: "light-blue",
  BLUE2_THEME: "blue2",
  BLUE2_LIGHT_THEME: "light-blue2",
  YELLOW_THEME: "yellow",
  YELLOW_LIGHT_THEME: "light-yellow",
  PURPLE_THEME: "purple",
  PURPLE_LIGHT_THEME: "light-purple",
  PREMIUM_THEME: "premium"
};
var LEGACY_THEMES_CORRELATION = {
  black: THEMES.BLACK_THEME,
  white: THEMES.WHITE_THEME,
  gray: THEMES.GRAY_THEME,
  red: THEMES.RED_THEME,
  "light-red": THEMES.RED_LIGHT_THEME,
  green: THEMES.GREEN_THEME,
  "light-green": THEMES.GREEN_LIGHT_THEME,
  orange: THEMES.ORANGE_THEME,
  "light-orange": THEMES.ORANGE_LIGHT_THEME,
  blue: THEMES.BLUE_THEME,
  "light-blue": THEMES.BLUE_LIGHT_THEME,
  blue2: THEMES.BLUE2_THEME,
  "light-blue2": THEMES.BLUE2_LIGHT_THEME,
  yellow: THEMES.YELLOW_THEME,
  "light-yellow": THEMES.YELLOW_LIGHT_THEME,
  purple: THEMES.PURPLE_THEME,
  "light-purple": THEMES.PURPLE_LIGHT_THEME,
  premium: THEMES.PREMIUM_THEME,
  "generic-blue": THEMES.BLUE_THEME,
  "generic-dark-blue": THEMES.BLUE_THEME,
  "generic-orange": THEMES.ORANGE_THEME,
  "generic-pink": THEMES.RED_THEME,
  "generic-green": THEMES.GREEN_THEME,
  "generic-purple": THEMES.PURPLE_THEME,
  "generic-yellow": THEMES.YELLOW_THEME,
  "his-blue1": THEMES.BLUE_THEME,
  "his-blue2": THEMES.BLUE_THEME,
  "his-dark-blue": THEMES.BLUE_THEME,
  "his-light-blue": THEMES.BLUE_THEME,
  "his-green1": THEMES.GREEN_THEME,
  "his-green2": THEMES.GREEN_THEME,
  "his-light-green": THEMES.GREEN_THEME,
  "his-dark-green": THEMES.GREEN_THEME,
  "his-orange1": THEMES.ORANGE_THEME,
  "his-orange2": THEMES.ORANGE_THEME,
  "his-purple": THEMES.PURPLE_THEME,
  "his-light-purple": THEMES.PURPLE_THEME,
  "his-red": THEMES.RED_THEME,
  "his-light-red1": THEMES.RED_THEME,
  "his-light-red2": THEMES.RED_THEME,
  "his-yellow": THEMES.YELLOW_THEME,
  "his-light-yellow": THEMES.YELLOW_THEME,
  "geo-blue1": THEMES.BLUE_THEME,
  "geo-blue2": THEMES.BLUE_THEME,
  "geo-light-blue": THEMES.BLUE_THEME,
  "geo-dark-blue": THEMES.BLUE_THEME,
  "geo-green1": THEMES.GREEN_THEME,
  "geo-green2": THEMES.GREEN_THEME,
  "geo-dark-green": THEMES.GREEN_THEME,
  "geo-light-green": THEMES.GREEN_THEME,
  "geo-orange1": THEMES.ORANGE_THEME,
  "geo-orange2": THEMES.ORANGE_THEME,
  "geo-dark-orange": THEMES.ORANGE_THEME,
  "geo-purple": THEMES.PURPLE_THEME,
  "geo-light-purple": THEMES.PURPLE_THEME,
  "geo-red": THEMES.RED_THEME,
  "geo-dark-red": THEMES.RED_THEME,
  "geo-yellow": THEMES.YELLOW_THEME,
  "geo-light-yellow": THEMES.YELLOW_THEME,
  "ses-blue1": THEMES.BLUE_THEME,
  "ses-blue2": THEMES.BLUE_THEME,
  "ses-dark-blue": THEMES.BLUE_THEME,
  "ses-light-blue": THEMES.BLUE_THEME,
  "ses-green1": THEMES.GREEN_THEME,
  "ses-green2": THEMES.GREEN_THEME,
  "ses-green3": THEMES.GREEN_THEME,
  "ses-light-green": THEMES.GREEN_THEME,
  "ses-orange": THEMES.ORANGE_THEME,
  "ses-light-orange": THEMES.ORANGE_THEME,
  "ses-purple": THEMES.PURPLE_THEME,
  "ses-light-purple": THEMES.PURPLE_THEME,
  "ses-red": THEMES.RED_THEME,
  "ses-light-red": THEMES.RED_THEME,
  "ses-yellow": THEMES.YELLOW_THEME,
  "ang-beige": THEMES.ORANGE_THEME,
  "ang-light-blue": THEMES.BLUE_THEME,
  "ang-green1": THEMES.GREEN_THEME,
  "ang-green2": THEMES.GREEN_THEME,
  "ang-dark-green": THEMES.GREEN_THEME,
  "ang-light-green1": THEMES.GREEN_THEME,
  "ang-light-green2": THEMES.GREEN_THEME,
  "ang-orange": THEMES.ORANGE_THEME,
  "ang-pink": THEMES.RED_THEME,
  "ang-purple": THEMES.PURPLE_THEME,
  "ang-light-purple": THEMES.PURPLE_THEME,
  "ang-red": THEMES.RED_THEME,
  "ang-red2": THEMES.RED_THEME,
  "ang-light-red": THEMES.RED_THEME,
  "ang-dark-red": THEMES.RED_THEME,
  "ang-light-yellow": THEMES.YELLOW_THEME,
  "ang-yellow1": THEMES.YELLOW_THEME,
  "ang-yellow2": THEMES.YELLOW_THEME,
  "esp-beige": THEMES.ORANGE_THEME,
  "esp-blue": THEMES.BLUE_THEME,
  "esp-light-blue": THEMES.BLUE_THEME,
  "esp-dark-blue": THEMES.BLUE_THEME,
  "esp-green1": THEMES.GREEN_THEME,
  "esp-green2": THEMES.GREEN_THEME,
  "esp-light-green": THEMES.GREEN_THEME,
  "esp-orange1": THEMES.ORANGE_THEME,
  "esp-orange2": THEMES.ORANGE_THEME,
  "esp-purple": THEMES.PURPLE_THEME,
  "esp-light-purple": THEMES.PURPLE_THEME,
  "esp-dark-purple": THEMES.PURPLE_THEME,
  "esp-pink": THEMES.RED_THEME,
  "esp-light-pink": THEMES.RED_THEME,
  "esp-red": THEMES.RED_THEME,
  "esp-light-red": THEMES.RED_THEME,
  "esp-dark-red": THEMES.RED_THEME,
  "esp-yellow": THEMES.YELLOW_THEME,
  "esp-light-yellow": THEMES.YELLOW_THEME,
  "fr-beige": THEMES.ORANGE_THEME,
  "fr-blue": THEMES.BLUE_THEME,
  "fr-light-green": THEMES.GREEN_THEME,
  "fr-green1": THEMES.GREEN_THEME,
  "fr-green2": THEMES.GREEN_THEME,
  "fr-green3": THEMES.GREEN_THEME,
  "fr-pink": THEMES.RED_THEME,
  "fr-light-pink": THEMES.RED_THEME,
  "fr-orange": THEMES.ORANGE_THEME,
  "fr-light-orange": THEMES.ORANGE_THEME,
  "fr-purple": THEMES.PURPLE_THEME,
  "fr-red": THEMES.RED_THEME,
  "maths-beige": THEMES.ORANGE_THEME,
  "maths-blue1": THEMES.BLUE_THEME,
  "maths-blue2": THEMES.BLUE_THEME,
  "maths-dark-blue": THEMES.BLUE_THEME,
  "maths-light-blue": THEMES.BLUE_THEME,
  "maths-green1": THEMES.GREEN_THEME,
  "maths-green2": THEMES.GREEN_THEME,
  "maths-green3": THEMES.GREEN_THEME,
  "maths-light-green": THEMES.GREEN_THEME,
  "maths-orange": THEMES.ORANGE_THEME,
  "maths-light-orange": THEMES.ORANGE_THEME,
  "maths-purple": THEMES.PURPLE_THEME,
  "maths-dark-purple": THEMES.PURPLE_THEME,
  "maths-light-purple": THEMES.PURPLE_THEME,
  "maths-pink": THEMES.RED_THEME,
  "maths-red": THEMES.RED_THEME,
  "maths-dark-red": THEMES.RED_THEME,
  "maths-light-red": THEMES.RED_THEME,
  "maths-yellow": THEMES.YELLOW_THEME,
  "maths-light-yellow": THEMES.YELLOW_THEME,
  "svt-blue1": THEMES.BLUE_THEME,
  "svt-blue2": THEMES.BLUE_THEME,
  "svt-light-blue": THEMES.BLUE_THEME,
  "svt-green1": THEMES.GREEN_THEME,
  "svt-green2": THEMES.GREEN_THEME,
  "svt-green3": THEMES.GREEN_THEME,
  "svt-light-green": THEMES.GREEN_THEME,
  "svt-orange1": THEMES.ORANGE_THEME,
  "svt-orange2": THEMES.ORANGE_THEME,
  "svt-pink1": THEMES.RED_THEME,
  "svt-pink2": THEMES.RED_THEME,
  "svt-red": THEMES.RED_THEME,
  "svt-light-red": THEMES.RED_THEME,
  "svt-yellow": THEMES.YELLOW_THEME,
  "svt-light-yellow": THEMES.YELLOW_THEME,
  "pc-beige": THEMES.ORANGE_THEME,
  "pc-blue1": THEMES.BLUE_THEME,
  "pc-blue2": THEMES.BLUE_THEME,
  "pc-dark-blue": THEMES.BLUE_THEME,
  "pc-light-blue": THEMES.BLUE_THEME,
  "pc-green1": THEMES.GREEN_THEME,
  "pc-green2": THEMES.GREEN_THEME,
  "pc-green3": THEMES.GREEN_THEME,
  "pc-light-green": THEMES.GREEN_THEME,
  "pc-orange": THEMES.ORANGE_THEME,
  "pc-pink": THEMES.RED_THEME,
  "pc-purple1": THEMES.PURPLE_THEME,
  "pc-purple2": THEMES.PURPLE_THEME,
  "pc-light-purple": THEMES.PURPLE_THEME,
  "pc-red": THEMES.RED_THEME,
  "pc-light-red": THEMES.RED_THEME,
  "pc-yellow": THEMES.YELLOW_THEME,
  "pc-light-yellow": THEMES.YELLOW_THEME,
  "sci-blue1": THEMES.BLUE_THEME,
  "sci-blue2": THEMES.BLUE_THEME,
  "sci-light-blue": THEMES.BLUE_THEME,
  "sci-green1": THEMES.GREEN_THEME,
  "sci-green2": THEMES.GREEN_THEME,
  "sci-green3": THEMES.GREEN_THEME,
  "sci-dark-green": THEMES.GREEN_THEME,
  "sci-light-green": THEMES.GREEN_THEME,
  "sci-orange": THEMES.ORANGE_THEME,
  "sci-purple": THEMES.PURPLE_THEME,
  "sci-light-purple": THEMES.PURPLE_THEME,
  "sci-red": THEMES.RED_THEME,
  "sci-light-red": THEMES.RED_THEME,
  "sci-yellow": THEMES.YELLOW_THEME,
  "sci-light-yellow": THEMES.YELLOW_THEME,
  "premium-pink": THEMES.RED_THEME,
  "premium-light-pink": THEMES.RED_THEME,
  "generic-blue-bg": THEMES.BLUE_THEME,
  "generic-dark-blue-bg": THEMES.BLUE_THEME,
  "generic-orange-bg": THEMES.ORANGE_THEME,
  "generic-pink-bg": THEMES.RED_THEME,
  "generic-green-bg": THEMES.GREEN_THEME,
  "generic-purple-bg": THEMES.PURPLE_THEME,
  "generic-yellow-bg": THEMES.YELLOW_THEME,
  "his-blue1-bg": THEMES.BLUE_THEME,
  "his-blue2-bg": THEMES.BLUE_THEME,
  "his-dark-blue-bg": THEMES.BLUE_THEME,
  "his-light-blue-bg": THEMES.BLUE_THEME,
  "his-green1-bg": THEMES.GREEN_THEME,
  "his-green2-bg": THEMES.GREEN_THEME,
  "his-light-green-bg": THEMES.GREEN_THEME,
  "his-dark-green-bg": THEMES.GREEN_THEME,
  "his-orange1-bg": THEMES.ORANGE_THEME,
  "his-orange2-bg": THEMES.ORANGE_THEME,
  "his-purple-bg": THEMES.PURPLE_THEME,
  "his-light-purple-bg": THEMES.PURPLE_THEME,
  "his-red-bg": THEMES.RED_THEME,
  "his-light-red1-bg": THEMES.RED_THEME,
  "his-light-red2-bg": THEMES.RED_THEME,
  "his-yellow-bg": THEMES.YELLOW_THEME,
  "his-light-yellow-bg": THEMES.YELLOW_THEME,
  "geo-blue1-bg": THEMES.BLUE_THEME,
  "geo-blue2-bg": THEMES.BLUE_THEME,
  "geo-light-blue-bg": THEMES.BLUE_THEME,
  "geo-dark-blue-bg": THEMES.BLUE_THEME,
  "geo-green1-bg": THEMES.GREEN_THEME,
  "geo-green2-bg": THEMES.GREEN_THEME,
  "geo-dark-green-bg": THEMES.GREEN_THEME,
  "geo-light-green-bg": THEMES.GREEN_THEME,
  "geo-orange1-bg": THEMES.ORANGE_THEME,
  "geo-orange2-bg": THEMES.ORANGE_THEME,
  "geo-dark-orange-bg": THEMES.ORANGE_THEME,
  "geo-purple-bg": THEMES.PURPLE_THEME,
  "geo-light-purple-bg": THEMES.PURPLE_THEME,
  "geo-red-bg": THEMES.RED_THEME,
  "geo-dark-red-bg": THEMES.RED_THEME,
  "geo-yellow-bg": THEMES.YELLOW_THEME,
  "geo-light-yellow-bg": THEMES.YELLOW_THEME,
  "ses-blue1-bg": THEMES.BLUE_THEME,
  "ses-blue2-bg": THEMES.BLUE_THEME,
  "ses-dark-blue-bg": THEMES.BLUE_THEME,
  "ses-light-blue-bg": THEMES.BLUE_THEME,
  "ses-green1-bg": THEMES.GREEN_THEME,
  "ses-green2-bg": THEMES.GREEN_THEME,
  "ses-green3-bg": THEMES.GREEN_THEME,
  "ses-light-green-bg": THEMES.GREEN_THEME,
  "ses-orange-bg": THEMES.ORANGE_THEME,
  "ses-light-orange-bg": THEMES.ORANGE_THEME,
  "ses-purple-bg": THEMES.PURPLE_THEME,
  "ses-light-purple-bg": THEMES.PURPLE_THEME,
  "ses-red-bg": THEMES.RED_THEME,
  "ses-light-red-bg": THEMES.RED_THEME,
  "ses-yellow-bg": THEMES.YELLOW_THEME,
  "ang-beige-bg": THEMES.ORANGE_THEME,
  "ang-light-blue-bg": THEMES.BLUE_THEME,
  "ang-green1-bg": THEMES.GREEN_THEME,
  "ang-green2-bg": THEMES.GREEN_THEME,
  "ang-dark-green-bg": THEMES.GREEN_THEME,
  "ang-light-green1-bg": THEMES.GREEN_THEME,
  "ang-light-green2-bg": THEMES.GREEN_THEME,
  "ang-orange-bg": THEMES.ORANGE_THEME,
  "ang-pink-bg": THEMES.RED_THEME,
  "ang-purple-bg": THEMES.PURPLE_THEME,
  "ang-light-purple-bg": THEMES.PURPLE_THEME,
  "ang-red-bg": THEMES.RED_THEME,
  "ang-red2-bg": THEMES.RED_THEME,
  "ang-light-red-bg": THEMES.RED_THEME,
  "ang-dark-red-bg": THEMES.RED_THEME,
  "ang-light-yellow-bg": THEMES.YELLOW_THEME,
  "ang-yellow1-bg": THEMES.YELLOW_THEME,
  "ang-yellow2-bg": THEMES.YELLOW_THEME,
  "esp-beige-bg": THEMES.ORANGE_THEME,
  "esp-blue-bg": THEMES.BLUE_THEME,
  "esp-light-blue-bg": THEMES.BLUE_THEME,
  "esp-dark-blue-bg": THEMES.BLUE_THEME,
  "esp-green1-bg": THEMES.GREEN_THEME,
  "esp-green2-bg": THEMES.GREEN_THEME,
  "esp-light-green-bg": THEMES.GREEN_THEME,
  "esp-orange1-bg": THEMES.ORANGE_THEME,
  "esp-orange2-bg": THEMES.ORANGE_THEME,
  "esp-purple-bg": THEMES.PURPLE_THEME,
  "esp-light-purple-bg": THEMES.PURPLE_THEME,
  "esp-dark-purple-bg": THEMES.PURPLE_THEME,
  "esp-pink-bg": THEMES.RED_THEME,
  "esp-light-pink-bg": THEMES.RED_THEME,
  "esp-red-bg": THEMES.RED_THEME,
  "esp-light-red-bg": THEMES.RED_THEME,
  "esp-dark-red-bg": THEMES.RED_THEME,
  "esp-yellow-bg": THEMES.YELLOW_THEME,
  "esp-light-yellow-bg": THEMES.YELLOW_THEME,
  "fr-beige-bg": THEMES.ORANGE_THEME,
  "fr-blue-bg": THEMES.BLUE_THEME,
  "fr-light-green-bg": THEMES.GREEN_THEME,
  "fr-green1-bg": THEMES.GREEN_THEME,
  "fr-green2-bg": THEMES.GREEN_THEME,
  "fr-green3-bg": THEMES.GREEN_THEME,
  "fr-pink-bg": THEMES.RED_THEME,
  "fr-light-pink-bg": THEMES.RED_THEME,
  "fr-orange-bg": THEMES.ORANGE_THEME,
  "fr-light-orange-bg": THEMES.ORANGE_THEME,
  "fr-purple-bg": THEMES.PURPLE_THEME,
  "fr-red-bg": THEMES.RED_THEME,
  "maths-beige-bg": THEMES.ORANGE_THEME,
  "maths-blue1-bg": THEMES.BLUE_THEME,
  "maths-blue2-bg": THEMES.BLUE_THEME,
  "maths-dark-blue-bg": THEMES.BLUE_THEME,
  "maths-light-blue-bg": THEMES.BLUE_THEME,
  "maths-green1-bg": THEMES.GREEN_THEME,
  "maths-green2-bg": THEMES.GREEN_THEME,
  "maths-green3-bg": THEMES.GREEN_THEME,
  "maths-light-green-bg": THEMES.GREEN_THEME,
  "maths-orange-bg": THEMES.ORANGE_THEME,
  "maths-light-orange-bg": THEMES.ORANGE_THEME,
  "maths-purple-bg": THEMES.PURPLE_THEME,
  "maths-dark-purple-bg": THEMES.PURPLE_THEME,
  "maths-light-purple-bg": THEMES.PURPLE_THEME,
  "maths-pink-bg": THEMES.RED_THEME,
  "maths-red-bg": THEMES.RED_THEME,
  "maths-dark-red-bg": THEMES.RED_THEME,
  "maths-light-red-bg": THEMES.RED_THEME,
  "maths-yellow-bg": THEMES.YELLOW_THEME,
  "maths-light-yellow-bg": THEMES.YELLOW_THEME,
  "svt-blue1-bg": THEMES.BLUE_THEME,
  "svt-blue2-bg": THEMES.BLUE_THEME,
  "svt-light-blue-bg": THEMES.BLUE_THEME,
  "svt-green1-bg": THEMES.GREEN_THEME,
  "svt-green2-bg": THEMES.GREEN_THEME,
  "svt-green3-bg": THEMES.GREEN_THEME,
  "svt-light-green-bg": THEMES.GREEN_THEME,
  "svt-orange1-bg": THEMES.ORANGE_THEME,
  "svt-orange2-bg": THEMES.ORANGE_THEME,
  "svt-pink1-bg": THEMES.RED_THEME,
  "svt-pink2-bg": THEMES.RED_THEME,
  "svt-red-bg": THEMES.RED_THEME,
  "svt-light-red-bg": THEMES.RED_THEME,
  "svt-yellow-bg": THEMES.YELLOW_THEME,
  "svt-light-yellow-bg": THEMES.YELLOW_THEME,
  "pc-beige-bg": THEMES.ORANGE_THEME,
  "pc-blue1-bg": THEMES.BLUE_THEME,
  "pc-blue2-bg": THEMES.BLUE_THEME,
  "pc-dark-blue-bg": THEMES.BLUE_THEME,
  "pc-light-blue-bg": THEMES.BLUE_THEME,
  "pc-green1-bg": THEMES.GREEN_THEME,
  "pc-green2-bg": THEMES.GREEN_THEME,
  "pc-green3-bg": THEMES.GREEN_THEME,
  "pc-light-green-bg": THEMES.GREEN_THEME,
  "pc-orange-bg": THEMES.ORANGE_THEME,
  "pc-pink-bg": THEMES.RED_THEME,
  "pc-purple1-bg": THEMES.PURPLE_THEME,
  "pc-purple2-bg": THEMES.PURPLE_THEME,
  "pc-light-purple-bg": THEMES.PURPLE_THEME,
  "pc-red-bg": THEMES.RED_THEME,
  "pc-light-red-bg": THEMES.RED_THEME,
  "pc-yellow-bg": THEMES.YELLOW_THEME,
  "pc-light-yellow-bg": THEMES.YELLOW_THEME,
  "sci-blue1-bg": THEMES.BLUE_THEME,
  "sci-blue2-bg": THEMES.BLUE_THEME,
  "sci-light-blue-bg": THEMES.BLUE_THEME,
  "sci-green1-bg": THEMES.GREEN_THEME,
  "sci-green2-bg": THEMES.GREEN_THEME,
  "sci-green3-bg": THEMES.GREEN_THEME,
  "sci-dark-green-bg": THEMES.GREEN_THEME,
  "sci-light-green-bg": THEMES.GREEN_THEME,
  "sci-orange-bg": THEMES.ORANGE_THEME,
  "sci-purple-bg": THEMES.PURPLE_THEME,
  "sci-light-purple-bg": THEMES.PURPLE_THEME,
  "sci-red-bg": THEMES.RED_THEME,
  "sci-light-red-bg": THEMES.RED_THEME,
  "sci-yellow-bg": THEMES.YELLOW_THEME,
  "sci-light-yellow-bg": THEMES.YELLOW_THEME,
  "premium-pink-bg": THEMES.RED_THEME,
  "premium-light-pink-bg": THEMES.RED_THEME
};

// src/utils/style.tsx
var getTruePx = (px) => `calc( var(--size-index, 1) * ${px}px)`;

// src/components/atoms/Icon.tsx
import { cx } from "@lls/utils";

// tmp_esbuild1736180047891/_src_components_atoms_Icon.module.css
var src_components_atoms_Icon_default = { "icon": "pkit-mw-DNq-icon" };

// src/components/atoms/Icon.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Icon = ({
  name,
  CustomAnimation,
  width: widthFromProps = "",
  height: heightFromProps = "",
  color = "currentColor",
  className,
  style,
  ...props
}) => {
  const IconComponent = (_3.isUndefined(CustomAnimation) ? _3.get(_3.toLower(name), ICONS_MAP) : CustomAnimation) ?? "span";
  return /* @__PURE__ */ jsx2(
    IconComponent,
    {
      style: {
        ...style,
        "--k-color": color,
        "--k-icon-width": getTruePx(widthFromProps),
        "--k-icon-height": getTruePx(heightFromProps)
      },
      "data-haswidth": +(widthFromProps !== ""),
      "data-hasheight": +(heightFromProps !== ""),
      className: cx(KIT_ICON_CLASSNAME, className, src_components_atoms_Icon_default.icon),
      ...props
    }
  );
};
var Icon_default = Icon;

// src/components/atoms/Chip.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var Chip = ({
  label,
  value,
  variant = "default",
  onClick,
  disabled = false,
  bigLabel = false,
  icon = "cancel",
  className,
  ...props
}) => {
  const isClickable = !_4.isUndefined(onClick) && !disabled;
  const handleClickChip = useCallback(() => {
    if (isClickable) onClick(value);
  }, [isClickable, onClick, value]);
  const isSingleAction = variant === "singleAction";
  const chipId = useMemo(() => _4.uniqueId("kit-chip-"), []);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cx2(className, src_components_atoms_Chip_default.chip),
      ...props,
      onClick: handleClickChip,
      "data-clickable": +isClickable,
      "data-disabled": +disabled,
      children: [
        !isSingleAction && /* @__PURE__ */ jsx3("label", { className: src_components_atoms_Chip_default.label, "data-biglabel": +bigLabel, htmlFor: chipId, children: label }),
        /* @__PURE__ */ jsx3("button", { type: "button", id: chipId, className: src_components_atoms_Chip_default.button, "data-is-single-action": +isSingleAction, children: /* @__PURE__ */ jsx3(
          Icon_default,
          {
            name: isSingleAction ? "plus" : icon,
            width: isSingleAction ? "16" : "10",
            height: isSingleAction ? "16" : "10"
          }
        ) })
      ]
    }
  );
};
var Chip_default = Chip;

// src/constants/button.tsx
var BUTTON_THEMES = {
  PRIMARY: "blue",
  SECONDARY: "yellow",
  GRAY: "gray",
  TERTIARY: "tertiary",
  PREMIUM: "premium",
  ERROR: "error",
  SUCCESS: "success"
};
var BUTTON_ACCENTS = {
  MAIN: "main",
  ALT: "alt",
  FLOATING: "floating"
};

// src/components/atoms/Button.tsx
import { cx as cx3 } from "@lls/utils";
import _5 from "lodash/fp.js";
import React, { useCallback as useCallback2 } from "react";

// tmp_esbuild1736180047891/_src_components_atoms_Button.module.css
var src_components_atoms_Button_default = { "filesInputContainer": "pkit-WQqW3W-filesInputContainer", "button": "pkit-WQqW3W-button", "buttonContent": "pkit-WQqW3W-buttonContent", "filesInput": "pkit-WQqW3W-filesInput" };

// src/components/atoms/Button.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var getIconSize = (size4) => {
  let sizeEm;
  switch (size4) {
    case "big":
      sizeEm = getTruePx(24);
      break;
    case "medium":
      sizeEm = getTruePx(20);
      break;
    case "xsmall":
      sizeEm = getTruePx(12);
      break;
    default:
      sizeEm = getTruePx(16);
      break;
  }
  return sizeEm;
};
var ButtonContent = ({
  icon = void 0,
  iconOnly,
  AnimatedIcon = void 0,
  animatedIconProps = {},
  iconPosition = "left",
  iconProps = {},
  children = void 0,
  size: size4
}) => /* @__PURE__ */ jsxs2(
  "span",
  {
    className: src_components_atoms_Button_default.buttonContent,
    "data-iconposition": iconPosition,
    "data-icononly": +iconOnly,
    style: {
      "--k-button-icon-size": getIconSize(size4)
    },
    children: [
      AnimatedIcon ? /* @__PURE__ */ jsx4(Icon_default, { CustomAnimation: AnimatedIcon, ...animatedIconProps }) : icon && /* @__PURE__ */ jsx4(Icon_default, { name: icon, ...iconProps }),
      !iconOnly && /* @__PURE__ */ jsx4("div", { children })
    ]
  }
);
var FileButton = React.forwardRef(
  ({ disabled, id, accept, multiple, onChange = _5.noop, buttonContentProps, ...props }, ref) => {
    return /* @__PURE__ */ jsxs2("div", { className: src_components_atoms_Button_default.filesInputContainer, children: [
      /* @__PURE__ */ jsx4(
        "input",
        {
          className: src_components_atoms_Button_default.filesInput,
          disabled,
          type: "file",
          id,
          accept,
          multiple,
          onChange
        }
      ),
      /* @__PURE__ */ jsx4("label", { htmlFor: id, ref, ...props, children: /* @__PURE__ */ jsx4(ButtonContent, { ...buttonContentProps }) })
    ] });
  }
);
var LinkButton = React.forwardRef(
  ({ onClick = _5.noop, href, page, doc, target, quiz, onGoTo, buttonContentProps, disabled, ...props }, ref) => {
    const onClickLink = useCallback2(
      (e) => {
        e.preventDefault();
        if (disabled) return;
        onGoTo == null ? void 0 : onGoTo({ page, doc, href, target, quiz });
        onClick(e);
      },
      [onGoTo, page, doc, href, target, quiz, disabled, onClick]
    );
    return /* @__PURE__ */ jsx4("a", { onClick: onClickLink, href, target, ref, ...props, children: /* @__PURE__ */ jsx4(ButtonContent, { ...buttonContentProps }) });
  }
);
var NormalButton = React.forwardRef(
  ({ type = "button", buttonContentProps, ...props }, ref) => {
    return /* @__PURE__ */ jsx4("button", { type, ref, ...props, children: /* @__PURE__ */ jsx4(ButtonContent, { ...buttonContentProps }) });
  }
);
var Button = React.forwardRef(
  ({
    children = void 0,
    theme: themeFromProps,
    accent: accentFromProps,
    error = false,
    // TODO error prop for backwards compatibility only : To remove if no used anymore
    icon = void 0,
    size: sizeFromProps,
    AnimatedIcon,
    animatedIconProps,
    iconPosition,
    iconProps,
    maxSize = false,
    inverted = false,
    disabled = false,
    className: classNameFromProps = "",
    onClick = _5.noop,
    onGoTo,
    style,
    ...props
  }, ref) => {
    const themename = error ? BUTTON_THEMES.ERROR : _5.includes(themeFromProps, _5.values(BUTTON_THEMES)) ? themeFromProps : BUTTON_THEMES.PRIMARY;
    const accent = _5.includes(accentFromProps, _5.values(BUTTON_ACCENTS)) ? accentFromProps : BUTTON_ACCENTS.MAIN;
    const iconOnly = _5.isEmpty(children);
    const size4 = sizeFromProps ?? (iconOnly ? "big" : "small");
    const prefix = `--button-${themename}-${accent}${disabled ? "-disabled" : ""}`;
    const buttonProps = {
      className: cx3(
        src_components_atoms_Button_default.button,
        KIT_BUTTON_CLASSNAME,
        classNameFromProps,
        inverted && KIT_CLASSNAME_INVERTED_THEME
      ),
      disabled,
      onClick,
      "data-rounded": +iconOnly,
      "data-maxsize": +maxSize,
      "data-disabled": +disabled,
      style: {
        ...style,
        "--k-button-color": `var(${prefix}-text)`,
        "--k-button-bgcolor": `var(${prefix}-bg)`,
        "--k-button-boxshadow": `var(${prefix}-shadow, none)`,
        "--kit-clickable-bg": `var(${prefix}-overlay)`
      },
      ...props
    };
    const buttonContentProps = {
      icon,
      iconOnly,
      AnimatedIcon,
      animatedIconProps,
      iconPosition,
      iconProps,
      children,
      size: size4
    };
    const isFile = "type" in buttonProps && buttonProps.type === "file";
    const isLink = "page" in buttonProps || "href" in buttonProps || "doc" in buttonProps;
    if (isLink) {
      return /* @__PURE__ */ jsx4(
        LinkButton,
        {
          ref,
          buttonContentProps,
          onGoTo,
          ...buttonProps
        }
      );
    }
    if (isFile) {
      return /* @__PURE__ */ jsx4(
        FileButton,
        {
          ref,
          buttonContentProps,
          ...buttonProps
        }
      );
    }
    return /* @__PURE__ */ jsx4(
      NormalButton,
      {
        ref,
        buttonContentProps,
        ...buttonProps
      }
    );
  }
);
var Button_default = Button;

// src/components/atoms/Divider.tsx
import { cx as cx4 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_components_atoms_Divider.module.css
var src_components_atoms_Divider_default = { "divider": "pkit-RG-8Jq-divider" };

// src/components/atoms/Divider.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var Divider = ({ vertical = false, inverted = false, className = "", ...props }) => {
  return /* @__PURE__ */ jsx5(
    "hr",
    {
      className: cx4(KIT_DIVIDER_CLASSNAME, className, inverted && KIT_CLASSNAME_INVERTED_THEME, src_components_atoms_Divider_default.divider),
      "data-vertical": +vertical,
      ...props
    }
  );
};
var Divider_default = Divider;

// src/components/atoms/IllustratedButton.tsx
import { cx as cx5 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_components_atoms_IllustratedButton.module.css
var src_components_atoms_IllustratedButton_default = { "illustrationContainer": "pkit-WN3n5W-illustrationContainer", "childrenContainer": "pkit-WN3n5W-childrenContainer", "container": "pkit-WN3n5W-container", "image": "pkit-WN3n5W-image" };

// src/components/atoms/IllustratedButton.tsx
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var IllustratedButton = ({
  illustration = "",
  position = "top",
  children,
  disabled = false,
  href,
  onClick,
  className,
  ...props
}) => {
  const Component = href ? "a" : "button";
  return /* @__PURE__ */ jsxs3(
    Component,
    {
      className: cx5(className, src_components_atoms_IllustratedButton_default.container, position === "top" ? "kit-button1" : "kit-body3"),
      disabled,
      "data-position": position,
      href,
      onClick: (e) => onClick(e, { href }),
      ...props,
      children: [
        /* @__PURE__ */ jsx6("div", { className: src_components_atoms_IllustratedButton_default.illustrationContainer, children: /* @__PURE__ */ jsx6("img", { className: src_components_atoms_IllustratedButton_default.image, src: illustration }) }),
        /* @__PURE__ */ jsx6("div", { className: src_components_atoms_IllustratedButton_default.childrenContainer, children })
      ]
    }
  );
};
var IllustratedButton_default = IllustratedButton;

// src/components/atoms/SwitchButton.tsx
import { cx as cx6 } from "@lls/utils";
import _6 from "lodash/fp.js";
import React2, { useCallback as useCallback3, useEffect as useEffect2, useState as useState2 } from "react";

// tmp_esbuild1736180047891/_src_components_atoms_SwitchButton.module.css
var src_components_atoms_SwitchButton_default = { "switchSlot": "pkit-1nWCnG-switchSlot", "toggleButton": "pkit-1nWCnG-toggleButton", "switchCursor": "pkit-1nWCnG-switchCursor", "icon": "pkit-1nWCnG-icon", "label": "pkit-1nWCnG-label", "switch": "pkit-1nWCnG-switch" };

// src/components/atoms/SwitchButton.tsx
import { Fragment, jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var SwitchButton = React2.forwardRef(
  ({
    value: valueFromProps = false,
    disabled = false,
    readonly = false,
    labelPosition = ELEMENT_POSITION.right,
    trueLabel,
    falseLabel,
    trueIcon,
    falseIcon,
    onChange = _6.noop,
    "data-tour": dataTour,
    className,
    ...props
  }, ref) => {
    const [value, setValue] = useState2(valueFromProps);
    const label = value ? trueLabel : falseLabel;
    const hasIcons = !!trueIcon && !!falseIcon;
    useEffect2(() => {
      setValue(valueFromProps);
    }, [valueFromProps]);
    const handleClick = useCallback3(
      (event) => {
        if (event) event.preventDefault();
        if (!disabled) {
          readonly ? onChange(value) : setValue((prevValue) => {
            const newValue = !prevValue;
            onChange(newValue);
            return newValue;
          });
        }
      },
      [disabled, onChange, value, readonly]
    );
    return /* @__PURE__ */ jsxs4(
      "div",
      {
        "data-isright": +(labelPosition === ELEMENT_POSITION.right),
        "data-disabled": +disabled,
        ref,
        onClick: handleClick,
        className: cx6(KIT_SWITCHBUTTON_CLASSNAME, className, src_components_atoms_SwitchButton_default.toggleButton),
        ...props,
        children: [
          /* @__PURE__ */ jsxs4("div", { className: src_components_atoms_SwitchButton_default.switch, "data-disabled": +disabled, "data-value": +value, "data-tour": dataTour, children: [
            hasIcons ? /* @__PURE__ */ jsxs4(Fragment, { children: [
              /* @__PURE__ */ jsx7(Icon_default, { className: src_components_atoms_SwitchButton_default.icon, name: falseIcon, width: 16, height: 16 }),
              /* @__PURE__ */ jsx7(Icon_default, { className: src_components_atoms_SwitchButton_default.icon, name: trueIcon, width: 16, height: 16 })
            ] }) : /* @__PURE__ */ jsx7("div", { className: src_components_atoms_SwitchButton_default.switchCursor }),
            /* @__PURE__ */ jsx7("div", { className: src_components_atoms_SwitchButton_default.switchSlot })
          ] }),
          label && /* @__PURE__ */ jsx7("span", { className: src_components_atoms_SwitchButton_default.label, children: label })
        ]
      }
    );
  }
);
var SwitchButton_default = SwitchButton;

// src/components/molecules/ButtonsList.tsx
import { cx as cx7 } from "@lls/utils";
import _7 from "lodash/fp.js";
import React3, { useCallback as useCallback4 } from "react";

// tmp_esbuild1736180047891/_src_components_molecules_ButtonsList.module.css
var src_components_molecules_ButtonsList_default = { "listMask": "pkit-ynFNNW-listMask", "buttonsListContainer": "pkit-ynFNNW-buttonsListContainer", "buttonsList": "pkit-ynFNNW-buttonsList" };

// src/components/molecules/ButtonsList.tsx
import { Fragment as Fragment2, jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var MenuItem = ({
  onButtonClick = _7.noop,
  type = "button",
  onClick,
  onChange,
  msg,
  disabled = false,
  content = null,
  ...props
}) => {
  const handleClick = useCallback4(
    (event) => {
      event.stopPropagation();
      if (onClick) {
        onClick();
        onButtonClick(event);
      }
    },
    [onButtonClick, onClick]
  );
  const handleChange = useCallback4(
    (event) => {
      if (!onChange) return;
      onButtonClick(event);
      onChange(event);
    },
    [onButtonClick, onChange]
  );
  switch (type) {
    case "component":
      return content ? React3.cloneElement(content, { handleClick, ...props }) : content;
    case "divider":
      return /* @__PURE__ */ jsx8(Divider_default, { ...props });
    case "switch": {
      const switchProps = _7.get("switchProps", props) || {};
      const buttonProps = _7.omit(["switchProps"], props);
      return /* @__PURE__ */ jsx8(Button_default, { theme: "gray", accent: "floating", disabled, ...buttonProps, onClick: handleClick, children: /* @__PURE__ */ jsx8(SwitchButton_default, { ...switchProps, disabled }) });
    }
    case "illustratedButton":
      return /* @__PURE__ */ jsx8(IllustratedButton_default, { onClick: handleClick, disabled, ...props, children: msg });
    default:
      return /* @__PURE__ */ jsx8(
        Button_default,
        {
          theme: "gray",
          accent: "floating",
          type,
          onClick: handleClick,
          onChange: handleChange,
          disabled,
          ...props,
          children: msg
        }
      );
  }
};
var ButtonsList = React3.forwardRef(
  ({
    listItems,
    withMask = true,
    zIndex = "auto",
    onMaskClick = _7.noop,
    onButtonClick = _7.noop,
    mode = "list",
    rowSize = 3,
    className,
    style,
    ...props
  }, ref) => {
    const onContainerClick = useCallback4((event) => {
      const isFile = _7.get("target.type", event) === "file";
      !isFile && event.preventDefault();
      event.stopPropagation();
    }, []);
    return /* @__PURE__ */ jsxs5(Fragment2, { children: [
      withMask && /* @__PURE__ */ jsx8("div", { className: src_components_molecules_ButtonsList_default.listMask, onClick: onMaskClick, style: { "--k-z-mask": zIndex } }),
      /* @__PURE__ */ jsx8(
        "div",
        {
          className: cx7(KIT_BUTTONSLIST_CLASSNAME, className, src_components_molecules_ButtonsList_default.buttonsListContainer),
          style: {
            ...style,
            "--k-z-buttons-list": zIndex
          },
          ...props,
          ref,
          onClick: onContainerClick,
          children: /* @__PURE__ */ jsx8(
            "div",
            {
              "data-mode": mode,
              className: src_components_molecules_ButtonsList_default.buttonsList,
              style: {
                "--k-buttonlist-grid-template": `repeat(${rowSize}, 1fr)`
              },
              children: listItems == null ? void 0 : listItems.map((item, index) => /* @__PURE__ */ jsx8(MenuItem, { onButtonClick, ...item }, index))
            }
          )
        }
      )
    ] });
  }
);
var ButtonsList_default = ButtonsList;

// src/components/quarks/Portal.tsx
import { createElement, useEffect as useEffect3, useRef, useState as useState3 } from "react";
import { createPortal } from "react-dom";

// src/utils/dom.tsx
import * as _8 from "lodash/fp.js";
var isBodyScrollDisabled = () => {
  return document.body.style.overflow === "hidden";
};
var disableBodyScroll = () => {
  document.body.style.overflow = "hidden";
};
var enableBodyScroll = () => {
  document.body.style.overflow = "";
};

// src/components/quarks/Portal.tsx
import _9 from "lodash/fp.js";

// tmp_esbuild1736180047891/_src_components_quarks_Portal.module.css
var src_components_quarks_Portal_default = { "hidden": "pkit-IeoI9G-hidden" };

// src/components/quarks/Portal.tsx
import { Fragment as Fragment3, jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var REGEXP_KIT_CONTAINER = new RegExp(`\\b${KIT_CLASSNAME_THEME_PREFIX}[^\\s]*\\b`);
var MUTATION_OBSERVER_CONFIG = {
  attributes: true,
  childList: false,
  attributeFilter: ["style", "class"]
};
var CSS_PROPERTIES_TO_INHERIT = ["--kitsizeindex", "--size-index", "font-family", "word-spacing"];
var Portal = ({ children, className = void 0, shouldDisableScroll = true, containerNode }) => {
  const hiddenRef = useRef(null);
  const rootEl = useRef(document.createElement("div"));
  const containerEl = useRef(document.createElement("div"));
  useEffect3(() => {
    var _a, _b;
    let observer;
    const closestParentWithTheme = (_a = hiddenRef.current) == null ? void 0 : _a.closest(`[class*='${KIT_CLASSNAME_THEME_PREFIX}']`);
    const setClassMode = () => {
      const closestTheme = closestParentWithTheme ? _9.get(0, closestParentWithTheme.className.match(REGEXP_KIT_CONTAINER)) : KIT_CLASSNAME_LIGHT_THEME;
      closestTheme && rootEl.current.setAttribute("class", `${KIT_PORTAL_CLASSNAME} ${closestTheme || ""}`);
    };
    setClassMode();
    if (closestParentWithTheme) {
      const closestParentComputedStyle = window.getComputedStyle(closestParentWithTheme, null);
      const setStyleAttribute = () => rootEl.current.setAttribute(
        "style",
        CSS_PROPERTIES_TO_INHERIT.map((property) => {
          const propValue = closestParentComputedStyle.getPropertyValue(property);
          if (propValue === "") return;
          return `${property}:  ${closestParentComputedStyle.getPropertyValue(property)};`;
        }).filter(Boolean).join("")
      );
      setStyleAttribute();
      observer = new MutationObserver((mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === "attributes") {
            setStyleAttribute();
            setClassMode();
            return;
          }
        }
      });
      observer.observe(closestParentWithTheme, MUTATION_OBSERVER_CONFIG);
    }
    className && containerEl.current.setAttribute("class", className);
    const closestPortalRoot = (_b = hiddenRef.current) == null ? void 0 : _b.closest(`.${KIT_PORTAL_ROOT_CLASSNAME}`);
    const portalNode = containerNode ?? closestPortalRoot ?? document.body;
    const bodyScrollAlreadyDisabled = isBodyScrollDisabled();
    if (shouldDisableScroll) {
      disableBodyScroll();
    }
    rootEl.current.appendChild(containerEl.current);
    const div = rootEl.current;
    portalNode.appendChild(rootEl.current);
    return () => {
      portalNode.removeChild(div);
      if (shouldDisableScroll && !bodyScrollAlreadyDisabled) {
        enableBodyScroll();
      }
      observer == null ? void 0 : observer.disconnect();
    };
  }, [shouldDisableScroll, className, containerNode]);
  return /* @__PURE__ */ jsxs6(Fragment3, { children: [
    /* @__PURE__ */ jsx9("span", { className: src_components_quarks_Portal_default.hidden, ref: hiddenRef }),
    createPortal(children, containerEl.current)
  ] });
};
var SsrSupportPortal = (props) => {
  const [showPortal, setShowPortal] = useState3(false);
  useEffect3(() => {
    setShowPortal(true);
  }, []);
  return showPortal ? createElement(Portal, props) : null;
};
var Portal_default = SsrSupportPortal;

// src/constants/chipSelect.tsx
var CHIP_SELECT_OFFSET = 8;

// src/constants/zIndex.tsx
var Z_MENU_BUTTON = 1301;
var Z_SELECT_CHIP = 1550;
var Z_BACKDROP = 1600;
var Z_CONFETTI = 1605;
var Z_TOOLTIP = 1750;

// src/components/molecules/ChipSelect.tsx
import { isInsideNode } from "@lls/utils";
import { cx as cx8 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_components_molecules_ChipSelect.module.css
var src_components_molecules_ChipSelect_default = { "chipSelect": "pkit-8M6M6a-chipSelect" };

// src/components/molecules/ChipSelect.tsx
import { jsx as jsx10, jsxs as jsxs7 } from "react/jsx-runtime";
var ChipSelect = ({
  label,
  options,
  selectedOption,
  onChange = _10.noop,
  disabled,
  optionsZIndex = Z_SELECT_CHIP,
  variant = "default",
  className,
  bigLabel = false,
  ...props
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState4(false);
  const [, startTransition] = useTransition();
  const toggleMenu = useCallback5(() => {
    if (!disabled) startTransition(() => setIsMenuOpen((previous) => !previous));
  }, [disabled]);
  const listItems = useMemo2(
    () => _10.map((option) => {
      const type = _10.get("type", option);
      if (type) return option;
      return {
        msg: _10.get("label", option),
        onClick: () => onChange(option),
        disabled: _10.getOr(false, "disabled", option)
      };
    }, options),
    [options, onChange]
  );
  const { refs, floatingStyles } = useFloating({
    whileElementsMounted: autoUpdate,
    placement: "bottom-start",
    middleware: [
      offset(CHIP_SELECT_OFFSET),
      flip(),
      shift(),
      size({
        apply({ availableWidth, availableHeight, elements }) {
          Object.assign(elements.floating.style, {
            maxWidth: `${availableWidth}px`,
            maxHeight: `${availableHeight}px`
          });
        }
      })
    ]
  });
  useEffect4(() => {
    if (isMenuOpen) {
      const outsideClickListener = (event) => {
        if (!isInsideNode(event, refs.domReference) && !isInsideNode(event, refs.floating)) {
          setIsMenuOpen(false);
        }
      };
      document.addEventListener("click", outsideClickListener);
      return () => {
        document.removeEventListener("click", outsideClickListener);
      };
    }
  }, [refs.domReference, refs.floating, isMenuOpen]);
  return /* @__PURE__ */ jsxs7("div", { className: cx8(className, src_components_molecules_ChipSelect_default.chipSelect), ref: refs.setReference, ...props, children: [
    isMenuOpen && /* @__PURE__ */ jsx10(Portal_default, { shouldDisableScroll: false, children: /* @__PURE__ */ jsx10(
      ButtonsList_default,
      {
        listItems,
        onButtonClick: toggleMenu,
        withMask: false,
        zIndex: optionsZIndex,
        ref: refs.setFloating,
        style: floatingStyles
      }
    ) }),
    selectedOption ? /* @__PURE__ */ jsx10(
      Chip_default,
      {
        label: _10.get("label", selectedOption),
        onClick: () => onChange(void 0),
        disabled,
        bigLabel
      }
    ) : /* @__PURE__ */ jsx10(
      Chip_default,
      {
        onClick: toggleMenu,
        variant,
        label,
        icon: isMenuOpen ? "chevronup" : "chevrondown",
        disabled,
        bigLabel
      }
    )
  ] });
};
var ChipSelect_default = ChipSelect;

// src/primary/constants/meli.tsx
import _11 from "lodash/fp.js";
var MELIS_MAP = _11.flow(
  _11.toPairs,
  _11.map(([name, component]) => [_11.toLower(name), component]),
  _11.fromPairs
)(MELI);

// src/primary/components/atoms/Meli.tsx
import { cx as cx9 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_primary_components_atoms_Meli.module.css
var src_primary_components_atoms_Meli_default = { "meli": "pkit-X2CTaq-meli" };

// src/primary/components/atoms/Meli.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var Meli = ({ name, width = 300, height = 300, className, style, ...props }) => {
  const MeliComponent = MELIS_MAP[name] ?? "span";
  return /* @__PURE__ */ jsx11(
    MeliComponent,
    {
      style: {
        ...style,
        "--pk-icon-width": getTruePx(width),
        "--pk-icon-height": getTruePx(height)
      },
      className: cx9(className, src_primary_components_atoms_Meli_default.meli),
      ...props
    }
  );
};
var Meli_default = Meli;

// src/primary/components/quarks/Dash.tsx
var dashStyle = ({
  dashThickness = 2,
  dashLength = 4,
  dashGap = 4,
  dashOffset = 0,
  radius = 16,
  color = "#000"
} = {}) => {
  const sanitizedColor = color.replace("#", "%23");
  return {
    borderRadius: `${radius}px`,
    backgroundPosition: "center",
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='${radius}' ry='${radius}' stroke='${sanitizedColor}' stroke-width='${dashThickness * 2}' stroke-dasharray='${dashLength - dashThickness * 2} ${dashGap + dashThickness * 2}' stroke-dashoffset='${dashOffset}' stroke-linecap='square'/%3e%3c/svg%3e")`
  };
};

// src/primary/components/quarks/Overlay.tsx
import { cx as cx10 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_primary_components_quarks_Overlay.module.css
var src_primary_components_quarks_Overlay_default = { "container": "pkit-JUOmnq-container", "overlay": "pkit-JUOmnq-overlay", "content": "pkit-JUOmnq-content" };

// src/primary/components/quarks/Overlay.tsx
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var OVERLAY_COLORS = {
  blue: "var(--pk-blue-20-color)",
  white: "var(--pk-white-color)",
  black: "var(--pk-black-color)"
};
var Overlay = ({
  children,
  disabled = false,
  color = "white",
  className,
  style,
  isHover: isForcedHover = false,
  isActive: isForcedActive = false
}) => {
  return /* @__PURE__ */ jsxs8(
    "div",
    {
      className: src_primary_components_quarks_Overlay_default.container,
      "data-disabled": +disabled,
      "data-forcedhover": +isForcedHover,
      "data-forcedactive": +isForcedActive,
      children: [
        /* @__PURE__ */ jsx12("div", { className: src_primary_components_quarks_Overlay_default.overlay, style: { "--kit-clickable-bg": OVERLAY_COLORS[color] } }),
        /* @__PURE__ */ jsx12("div", { className: cx10(className, src_primary_components_quarks_Overlay_default.content), style, children })
      ]
    }
  );
};
var Overlay_default = Overlay;

// src/primary/constants/palette.tsx
var PALETTE_BLUE = {
  10: "#E8F4FF",
  20: "#B3DAFF",
  30: "#4E98DF",
  40: "#00488D",
  50: "#002E4D"
};
var PALETTE_ORANGE = {
  10: "#FFF0DA",
  20: "#FFD9A0",
  30: "#FFB241",
  40: "#AB6605",
  50: "#873800"
};
var PALETTE_PINK = {
  10: "#FFD5E4",
  20: "#F08BAF",
  30: "#FF669C",
  40: "#D8145A",
  50: "#920537"
};
var PALETTE_GREEN = {
  10: "#EDFED7",
  20: "#C4E1A0",
  30: "#81C331",
  40: "#458000",
  50: "#2E5402"
};
var PALETTE_PURPLE = {
  10: "#E1D2EE",
  20: "#C1A8D6",
  30: "#A788C2",
  40: "#836F94",
  50: "#453C4D"
};
var BLUE = PALETTE_BLUE[40];
var ORANGE = PALETTE_ORANGE[30];
var PINK = PALETTE_PINK[30];
var GREEN = PALETTE_GREEN[30];
var PURPLE = PALETTE_PURPLE[20];
var WHITE = "#FFF";
var DISABLED_CONTENT = "#B8C3D9";
var TEXT_BLUE = PALETTE_BLUE[50];
var TEXT_WHITE = WHITE;

// src/primary/constants/button.ts
var disabledDashColor = DISABLED_CONTENT;
var disabledColor = "var(--pk-disabled-content-color)";
var BUTTON_THEMES2 = {
  blue: {
    text: "var(--pk-text-white-color)",
    bg: "var(--pk-blue-40-color)",
    disabledColor,
    bgDisabledColor: "var(--pk-disabled-surface-color)",
    dashRadius: 4,
    dashThickness: 1,
    dashLength: 4,
    dashGap: 4,
    dashColor: TEXT_WHITE,
    disabledDashColor
  },
  orange: {
    text: "var(--pk-text-blue-color)",
    bg: "var(--pk-orange-30-color)",
    disabledColor,
    bgDisabledColor: "var(--pk-disabled-surface-color)",
    dashRadius: 4,
    dashThickness: 1,
    dashLength: 4,
    dashGap: 4,
    dashColor: TEXT_BLUE,
    disabledDashColor
  },
  white: {
    text: "var(--pk-text-blue-color)",
    bg: "var(--pk-white-color)",
    disabledColor,
    bgDisabledColor: "var(--pk-disabled-surface-color)",
    dashRadius: 4,
    dashThickness: 1,
    dashLength: 4,
    dashGap: 4,
    dashColor: TEXT_BLUE,
    disabledDashColor
  },
  floatingWhite: {
    text: "var(--pk-text-white-color)",
    bg: "none",
    disabledColor,
    bgDisabledColor: "transparent",
    dashRadius: 4,
    dashThickness: 1,
    dashLength: 4,
    dashGap: 4,
    dashColor: TEXT_WHITE,
    disabledDashColor
  },
  floatingBlue: {
    text: "var(--pk-text-blue-color)",
    bg: "none",
    disabledColor,
    bgDisabledColor: "transparent",
    dashRadius: 4,
    dashThickness: 1,
    dashLength: 4,
    dashGap: 4,
    dashColor: TEXT_BLUE,
    disabledDashColor
  },
  pink: {
    text: "var(--pk-pink-40-color)",
    bg: "var(--pk-pink-10-color)",
    disabledColor,
    bgDisabledColor: "var(--pk-disabled-surface-color)",
    dashRadius: 4,
    dashThickness: 2,
    dashLength: 8,
    dashGap: 8,
    dashColor: PALETTE_PINK[40],
    disabledDashColor
  },
  green: {
    text: "var(--pk-green-40-color)",
    bg: "var(--pk-green-10-color)",
    disabledColor,
    bgDisabledColor: "var(--pk-disabled-surface-color)",
    dashRadius: 4,
    dashThickness: 2,
    dashLength: 8,
    dashGap: 8,
    dashColor: PALETTE_GREEN[40],
    disabledDashColor
  },
  purple: {
    text: "var(--pk-purple-50-color)",
    bg: "var(--pk-purple-10-color)",
    disabledColor,
    bgDisabledColor: "var(--pk-disabled-surface-color)",
    dashRadius: 4,
    dashThickness: 2,
    dashLength: 8,
    dashGap: 8,
    dashColor: PALETTE_PURPLE[50],
    disabledDashColor
  }
};

// src/primary/components/atoms/Button.tsx
import { cx as cx11 } from "@lls/utils";
import _12 from "lodash/fp.js";
import React4 from "react";

// tmp_esbuild1736180047891/_src_primary_components_atoms_Button.module.css
var src_primary_components_atoms_Button_default = { "buttonContent": "pkit-YpAc4W-buttonContent", "filesInput": "pkit-YpAc4W-filesInput", "buttonChildren": "pkit-YpAc4W-buttonChildren", "button": "pkit-YpAc4W-button", "meli": "pkit-YpAc4W-meli", "dash": "pkit-YpAc4W-dash" };

// src/primary/components/atoms/Button.tsx
import { Fragment as Fragment4, jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var ButtonContent2 = ({
  overlayColor,
  dashRadius,
  dashColor,
  dashThickness,
  dashLength,
  dashGap,
  dashed,
  meli,
  iconLeft,
  iconRight,
  iconLeftProps,
  iconRightProps,
  iconOnly,
  disabled,
  children = /* @__PURE__ */ jsx13(Fragment4, { children: "\xA0" })
}) => {
  const iconSize = iconOnly ? 24 : 16;
  return /* @__PURE__ */ jsxs9(Overlay_default, { color: overlayColor, disabled, children: [
    dashed && /* @__PURE__ */ jsx13(
      "span",
      {
        className: src_primary_components_atoms_Button_default.dash,
        style: dashStyle({
          radius: iconOnly ? iconSize : dashRadius,
          color: dashColor,
          dashLength: iconOnly ? 3 : dashLength,
          dashGap: iconOnly ? 3 : dashGap,
          dashThickness
        })
      }
    ),
    /* @__PURE__ */ jsxs9("span", { className: src_primary_components_atoms_Button_default.buttonContent, children: [
      iconLeft && /* @__PURE__ */ jsx13(Icon_default, { name: iconLeft, width: iconSize, height: iconSize, ...iconLeftProps }),
      !iconOnly && /* @__PURE__ */ jsx13("span", { className: src_primary_components_atoms_Button_default.buttonChildren, children }),
      iconRight && /* @__PURE__ */ jsx13(Icon_default, { name: iconRight, width: iconSize, height: iconSize, ...iconRightProps }),
      meli && /* @__PURE__ */ jsx13(Meli_default, { name: meli, width: 48, height: 48, className: src_primary_components_atoms_Button_default.meli })
    ] })
  ] });
};
var NormalButton2 = React4.forwardRef(({ buttonContentProps, ...props }, ref) => {
  return /* @__PURE__ */ jsx13("button", { ...props, ref, children: /* @__PURE__ */ jsx13(ButtonContent2, { ...buttonContentProps }) });
});
var LinkButton2 = React4.forwardRef(({ buttonContentProps, onGoTo, href, target, disabled, onClick, ...props }, ref) => {
  const onClickLink = (e) => {
    !!onGoTo && e.preventDefault();
    if (disabled) return;
    onGoTo == null ? void 0 : onGoTo(href, target);
    onClick == null ? void 0 : onClick(e);
  };
  return /* @__PURE__ */ jsx13("a", { ...props, ref, onClick: onClickLink, href, target, children: /* @__PURE__ */ jsx13(ButtonContent2, { ...buttonContentProps }) });
});
var FileButton2 = React4.forwardRef(({ disabled = false, id, accept, multiple, onChange = _12.noop, buttonContentProps, ...props }, ref) => /* @__PURE__ */ jsxs9(Fragment4, { children: [
  /* @__PURE__ */ jsx13(
    "input",
    {
      className: src_primary_components_atoms_Button_default.filesInput,
      disabled,
      type: "file",
      id,
      accept,
      multiple,
      onChange
    }
  ),
  /* @__PURE__ */ jsx13("label", { htmlFor: id, ...props, ref, children: /* @__PURE__ */ jsx13(ButtonContent2, { ...buttonContentProps }) })
] }));
var BUTTON_OVERLAY_LINK = {
  blue: "black",
  orange: "white",
  white: "blue",
  floatingWhite: "white",
  floatingBlue: "blue",
  pink: "white",
  green: "blue",
  purple: "white"
};
var Button2 = React4.forwardRef(
  ({
    children,
    type = "button",
    dashed = false,
    theme = "blue",
    iconLeft,
    iconLeftProps,
    iconRight,
    iconRightProps,
    meli,
    size: size4 = "normal",
    className,
    disabled = false,
    style,
    ...props
  }, ref) => {
    const iconOnly = !!(_12.isEmpty(children) && (iconLeft || iconRight));
    const overlayColor = BUTTON_OVERLAY_LINK[theme];
    const buttonProps = {
      className: cx11(src_primary_components_atoms_Button_default.button, className),
      disabled,
      type,
      "data-size": size4,
      "data-rounded": +iconOnly,
      "data-disabled": +disabled,
      style: {
        ...style,
        "--pk-button-color": disabled ? BUTTON_THEMES2[theme].disabledColor : BUTTON_THEMES2[theme].text,
        "--pk-button-bgcolor": disabled ? BUTTON_THEMES2[theme].bgDisabledColor : BUTTON_THEMES2[theme].bg
      },
      ...props
    };
    const buttonContentProps = {
      overlayColor,
      dashed,
      dashRadius: BUTTON_THEMES2[theme].dashRadius,
      dashColor: disabled ? BUTTON_THEMES2[theme].disabledDashColor : BUTTON_THEMES2[theme].dashColor,
      dashThickness: BUTTON_THEMES2[theme].dashThickness,
      dashLength: BUTTON_THEMES2[theme].dashLength,
      dashGap: BUTTON_THEMES2[theme].dashGap,
      meli,
      iconLeft,
      iconLeftProps,
      iconRight,
      iconRightProps,
      iconOnly,
      disabled,
      children
    };
    if (type === "file")
      return /* @__PURE__ */ jsx13(
        FileButton2,
        {
          buttonContentProps,
          ...buttonProps,
          ref
        }
      );
    if ("href" in props)
      return /* @__PURE__ */ jsx13(
        LinkButton2,
        {
          buttonContentProps,
          ...buttonProps,
          ref
        }
      );
    return /* @__PURE__ */ jsx13(
      NormalButton2,
      {
        buttonContentProps,
        ...buttonProps,
        ref
      }
    );
  }
);
var Button_default2 = Button2;

// src/utils/react.tsx
import _13 from "lodash/fp.js";
var separateDataAttrFromProps = (props) => [
  _13.pickBy((_val, key) => _13.startsWith("data-", key), props),
  _13.omitBy((_val, key) => _13.startsWith("data-", key), props)
];

// src/primary/components/atoms/CheckBox.tsx
import { cx as cx12, useControlled } from "@lls/utils";
import React5, { useState as useState5 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_atoms_CheckBox.module.css
var src_primary_components_atoms_CheckBox_default = { "checkboxContainer": "pkit-Qu1jna-checkboxContainer", "checkBox": "pkit-Qu1jna-checkBox", "overlayContainer": "pkit-Qu1jna-overlayContainer", "checkBoxOuter": "pkit-Qu1jna-checkBoxOuter", "icon": "pkit-Qu1jna-icon", "label": "pkit-Qu1jna-label", "checkboxContent": "pkit-Qu1jna-checkboxContent" };

// src/primary/components/atoms/CheckBox.tsx
import { jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var CheckBox = React5.forwardRef(
  ({
    isChecked: isCheckedFromProps = false,
    disabled = false,
    indeterminate = false,
    label = "",
    setIsChecked: setIsCheckedFromProps,
    className,
    icon,
    style,
    ...props
  }, ref) => {
    const [isChecked, setIsChecked] = useControlled(isCheckedFromProps, setIsCheckedFromProps);
    const [isOverlayActive, setIsOverlayActive] = useState5(false);
    const [isHovered, setIsHovered] = useState5(false);
    const handleChange = (event) => {
      setIsChecked(event.target.checked);
    };
    const [dataAttributes, otherProps] = separateDataAttrFromProps(props);
    return /* @__PURE__ */ jsxs10(
      "label",
      {
        className: cx12(className, src_primary_components_atoms_CheckBox_default.checkboxContainer),
        "data-is-disabled": +disabled,
        onMouseDown: () => setIsOverlayActive(true),
        onMouseUp: () => setIsOverlayActive(false),
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
        style: {
          ...style,
          "--pk-checkbox-color": disabled ? "var(--pk-disabled-content-color)" : "var(--pk-text-blue-color)"
        },
        ...dataAttributes,
        children: [
          /* @__PURE__ */ jsxs10("div", { className: src_primary_components_atoms_CheckBox_default.checkboxContent, children: [
            /* @__PURE__ */ jsx14("div", { className: src_primary_components_atoms_CheckBox_default.overlayContainer, children: /* @__PURE__ */ jsx14(Overlay_default, { isHover: isHovered, isActive: isOverlayActive, disabled, color: "blue", children: /* @__PURE__ */ jsx14("div", { className: src_primary_components_atoms_CheckBox_default.checkBoxOuter, contentEditable: false, children: /* @__PURE__ */ jsx14(
              "input",
              {
                "data-is-indeterminate": +indeterminate,
                className: src_primary_components_atoms_CheckBox_default.checkBox,
                type: "checkbox",
                ref,
                disabled,
                checked: isChecked,
                onChange: handleChange,
                ...otherProps
              }
            ) }) }) }),
            label && /* @__PURE__ */ jsx14("div", { className: src_primary_components_atoms_CheckBox_default.label, children: label })
          ] }),
          icon && /* @__PURE__ */ jsx14(Icon_default, { className: src_primary_components_atoms_CheckBox_default.icon, width: 24, height: 24, name: icon })
        ]
      }
    );
  }
);
var CheckBox_default = CheckBox;

// src/primary/components/atoms/Chip.tsx
import { cx as cx13 } from "@lls/utils";
import _14 from "lodash/fp.js";
import { useMemo as useMemo3 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_atoms_Chip.module.css
var src_primary_components_atoms_Chip_default = { "chip": "pkit-4eldkG-chip", "label": "pkit-4eldkG-label", "container": "pkit-4eldkG-container", "button": "pkit-4eldkG-button" };

// src/primary/components/atoms/Chip.tsx
import { jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
var Chip2 = ({
  label,
  value,
  variant = "default",
  onClick,
  disabled = false,
  icon = "cancel",
  className,
  ...props
}) => {
  const isClickable = !!onClick && !disabled;
  const handleClickChip = () => {
    if (isClickable) onClick(value);
  };
  const isSingleAction = variant === "singleAction";
  const chipId = useMemo3(() => _14.uniqueId("kit-primary-chip-id-"), []);
  return /* @__PURE__ */ jsx15(
    "div",
    {
      className: src_primary_components_atoms_Chip_default.container,
      "data-clickable": +isClickable,
      "data-disabled": +disabled,
      onClick: handleClickChip,
      children: /* @__PURE__ */ jsx15(Overlay_default, { disabled, color: "white", children: /* @__PURE__ */ jsxs11("div", { className: cx13(className, src_primary_components_atoms_Chip_default.chip), ...props, children: [
        !isSingleAction && /* @__PURE__ */ jsx15("label", { className: src_primary_components_atoms_Chip_default.label, htmlFor: chipId, children: label }),
        /* @__PURE__ */ jsx15("button", { className: src_primary_components_atoms_Chip_default.button, id: chipId, children: /* @__PURE__ */ jsx15(Icon_default, { name: isSingleAction ? "plus" : icon, width: "16", height: "16" }) })
      ] }) })
    }
  );
};
var Chip_default2 = Chip2;

// src/primary/components/quarks/Divider.tsx
var dividerStyle = ({
  dashThickness = 2,
  dashLength = 8,
  dashGap = 8,
  color = "#000",
  vertical = false
} = {}) => {
  const sanitizedColor = color.replace("#", "%23");
  return {
    backgroundPosition: "center",
    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3cline x1='1' y1='1' x2='${vertical ? "1" : "100%25"}' y2='${vertical ? "100%25" : "1"}' stroke='${sanitizedColor}' stroke-width='${dashThickness * 2}' stroke-dasharray='${dashLength} ${dashGap}' /%3e%3c/svg%3e")`
  };
};

// src/primary/components/atoms/Divider.tsx
import { cx as cx14 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_primary_components_atoms_Divider.module.css
var src_primary_components_atoms_Divider_default = { "dash": "pkit-Y_gWIa-dash", "divider": "pkit-Y_gWIa-divider" };

// src/primary/components/atoms/Divider.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var Divider2 = ({ vertical = false, className = "", ...props }) => {
  return /* @__PURE__ */ jsx16("div", { className: cx14(className, src_primary_components_atoms_Divider_default.divider), "data-vertical": +vertical, ...props, children: /* @__PURE__ */ jsx16("div", { className: src_primary_components_atoms_Divider_default.dash, style: dividerStyle({ color: "#E8F4FF", vertical }) }) });
};
var Divider_default2 = Divider2;

// src/utils/range.tsx
import _15 from "lodash/fp.js";
var getDecimals = (n) => _15.flow(
  _15.toString,
  (str) => {
    if (_15.includes("-", str)) return _15.flow(_15.split("-"), _15.get(1))(str);
    if (_15.includes(".", str)) return _15.flow(_15.split("."), _15.get(1), _15.size)(str);
  },
  _15.defaultTo(0)
)(n);
var getRoundedNewValueFromPos = ({ pos, step, min, max }) => getRoundedvalue(pos * (max - min) + min, step);
var getRoundedvalue = (n, step) => {
  const nDecimals = getDecimals(step);
  const factor = 10 ** nDecimals;
  return Math.round(n * factor) / factor;
};

// src/primary/components/atoms/ProgressBar.tsx
import { cx as cx15, getClientPosition } from "@lls/utils";
import _16 from "lodash/fp.js";
import { useCallback as useCallback6, useEffect as useEffect5, useRef as useRef2, useState as useState6 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_atoms_ProgressBar.module.css
var src_primary_components_atoms_ProgressBar_default = { "trackStart": "pkit-ujsLNW-trackStart", "trackEnd": "pkit-ujsLNW-trackEnd", "progressbarContainer": "pkit-ujsLNW-progressbarContainer", "thumb": "pkit-ujsLNW-thumb" };

// src/primary/components/atoms/ProgressBar.tsx
import { jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";
var ProgressBar = ({
  step = 1,
  min = 0,
  max = 100,
  onChange = _16.noop,
  value: valueFromProps,
  width = "100%",
  height = "100%",
  vertical = false,
  showTip = true,
  triggerAtDrag = true,
  className,
  style,
  ...props
}) => {
  const containerRef = useRef2(null);
  const [thumbPosition, setThumbPosition] = useState6(0);
  const [isPressed, setIsPressed] = useState6(false);
  const [value, setValue] = useState6(valueFromProps);
  useEffect5(() => {
    if (step <= 0) console.error("Step doit \xEAtre sup\xE9rieur \xE0 0");
  }, [step]);
  useEffect5(() => {
    if (max <= min) {
      console.error("max doit \xEAtre strictement sup\xE9rieur \xE0 min");
      return;
    }
    if (!_16.isUndefined(valueFromProps) && !isPressed) {
      setValue(valueFromProps);
      setThumbPosition((valueFromProps - min) * 100 / (max - min));
    }
  }, [isPressed, valueFromProps, max, min]);
  const onClickTrack = useCallback6(
    (e) => {
      if (!containerRef.current) return;
      const { top, left } = containerRef.current.getBoundingClientRect();
      const { x: clientX, y: clientY } = getClientPosition(e);
      const absolutePos = vertical ? (containerRef.current.offsetHeight - clientY + top) / containerRef.current.offsetHeight : (clientX - left) / containerRef.current.offsetWidth;
      const posClamped = _16.clamp(0, 1, absolutePos);
      const totalSteps = max - min > 0 ? (max - min) / (step || 1) : 1;
      const pos = Math.round(posClamped * totalSteps) / totalSteps;
      setThumbPosition(pos * 100);
      const newValue = getRoundedNewValueFromPos({ pos, step, min, max });
      setValue(newValue);
      if (triggerAtDrag) onChange(newValue);
    },
    [max, min, step, vertical, triggerAtDrag, onChange]
  );
  const valueRef = useRef2(value);
  valueRef.current = value;
  useEffect5(() => {
    if (!window || !isPressed) return;
    const handleTouchMove = (e) => {
      e.cancelable && e.preventDefault();
      onClickTrack(e);
    };
    const handleTouchEnd = (e) => {
      e.cancelable && e.preventDefault();
      onChange(valueRef.current);
      setIsPressed(false);
    };
    window.addEventListener("touchend", handleTouchEnd, { passive: false });
    window.addEventListener("touchmove", handleTouchMove, { passive: false });
    window.addEventListener("mousemove", handleTouchMove, { passive: false });
    window.addEventListener("mouseup", handleTouchEnd, { passive: false });
    return () => {
      window.removeEventListener("touchend", handleTouchEnd);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("mousemove", handleTouchMove);
      window.removeEventListener("mouseup", handleTouchEnd);
    };
  }, [isPressed, onClickTrack, onChange]);
  return /* @__PURE__ */ jsxs12(
    "div",
    {
      className: cx15(className, src_primary_components_atoms_ProgressBar_default.progressbarContainer),
      style: {
        ...style,
        "--pk-height": height,
        "--pk-width": width
      },
      ref: containerRef,
      ...props,
      "data-vertical": +vertical,
      "data-ispressed": +isPressed,
      onMouseDown: (e) => {
        onClickTrack(e);
        setIsPressed(true);
      },
      onTouchStart: (e) => {
        onClickTrack(e);
        setIsPressed(true);
      },
      children: [
        /* @__PURE__ */ jsx17(
          "div",
          {
            className: src_primary_components_atoms_ProgressBar_default.trackStart,
            style: { "--pk-thumbPosition": `${thumbPosition}%` },
            "data-vertical": +vertical
          }
        ),
        /* @__PURE__ */ jsx17("div", { className: src_primary_components_atoms_ProgressBar_default.trackEnd, "data-vertical": +vertical }),
        /* @__PURE__ */ jsx17(
          "div",
          {
            className: src_primary_components_atoms_ProgressBar_default.thumb,
            style: {
              "--pk-bottom": `${vertical ? thumbPosition : 50}%`,
              "--pk-left": `${vertical ? 50 : thumbPosition}%`
            }
          }
        )
      ]
    }
  );
};
var ProgressBar_default = ProgressBar;

// src/primary/components/atoms/Scrim.tsx
import { cx as cx16 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_primary_components_atoms_Scrim.module.css
var src_primary_components_atoms_Scrim_default = { "scrim": "pkit-xVOCgq-scrim" };

// src/primary/components/atoms/Scrim.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var Scrim = ({ className, ...props }) => {
  return /* @__PURE__ */ jsx18("div", { className: cx16(className, src_primary_components_atoms_Scrim_default.scrim), ...props });
};
var Scrim_default = Scrim;

// src/primary/components/atoms/Tab.tsx
import React6, { useEffect as useEffect8, useState as useState9 } from "react";

// src/components/atoms/Tooltip.tsx
import {
  FloatingArrow,
  arrow,
  autoUpdate as autoUpdate2,
  flip as flip2,
  hide,
  inline,
  limitShift,
  offset as offset2,
  shift as shift2,
  size as size2,
  useFloating as useFloating2
} from "@floating-ui/react";

// src/constants/tooltip.tsx
var TOOLTIP_MARGIN = 3;

// src/hooks/useLongPress.tsx
import _17 from "lodash/fp.js";
import { useEffect as useEffect6, useRef as useRef3, useState as useState7 } from "react";
var useLongPress = ({ callback = _17.noop, target = "all", delay = 600 }) => {
  const [startLongPress, setStartLongPress] = useState7(false);
  const callbackRef = useRef3(callback);
  callbackRef.current = callback;
  useEffect6(() => {
    if (startLongPress) {
      const timerId = setTimeout(callbackRef.current, delay);
      return () => {
        clearTimeout(timerId);
      };
    }
  }, [delay, startLongPress]);
  const start = () => {
    setStartLongPress(true);
  };
  const stop = () => {
    setStartLongPress(false);
  };
  const touchListeners = {
    onTouchStart: start,
    onTouchEnd: stop
  };
  const mouseListeners = {
    onMouseDown: start,
    onMouseUp: stop,
    onMouseLeave: stop
  };
  return {
    ...["touch", "all"].includes(target) ? touchListeners : void 0,
    ...["mouse", "all"].includes(target) ? mouseListeners : void 0
  };
};
var useLongPress_default = useLongPress;

// src/utils/browser.tsx
var isTouchDevice = () => {
  var _a;
  return Boolean((_a = window == null ? void 0 : window.matchMedia("(pointer: coarse)")) == null ? void 0 : _a.matches);
};

// src/components/atoms/Tooltip.tsx
import { cx as cx17, isInsideNode as isInsideNode2 } from "@lls/utils";
import _18 from "lodash/fp.js";
import { cloneElement, isValidElement, useEffect as useEffect7, useRef as useRef4, useState as useState8, useTransition as useTransition2 } from "react";

// tmp_esbuild1736180047891/_src_components_atoms_Tooltip.module.css
var src_components_atoms_Tooltip_default = { "span": "pkit-SQYQOa-span", "tooltipRoot": "pkit-SQYQOa-tooltipRoot", "tooltip": "pkit-SQYQOa-tooltip", "tooltipContainer": "pkit-SQYQOa-tooltipContainer" };

// src/components/atoms/Tooltip.tsx
import { jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var TOOLTIP_TOUCH_DURATION = 3e3;
var TOOLTIP_HOVER_MAX_DURATION = 1e4;
var useTooltipOpening = ({
  trigger,
  open = false,
  disabled = false,
  tooltipRef,
  componentRef,
  startTransition,
  ...props
}) => {
  const [isChildrenHover, setIsChildrenHover] = useState8(false);
  const [isTooltipHover, setIsTooltipHover] = useState8(false);
  const [isMobile, setIsMobile] = useState8(false);
  const onLongPress = () => {
    !disabled && setIsChildrenHover(true);
  };
  const longPressListeners = useLongPress_default({ callback: onLongPress });
  const shouldDetectOutsideClick = trigger === "click" && !disabled && isChildrenHover;
  useEffect7(() => {
    setIsMobile(isTouchDevice());
  }, []);
  useEffect7(() => {
    if (!shouldDetectOutsideClick) return;
    const onClickLeave = (e) => {
      if (isInsideNode2(e, componentRef)) {
        setIsChildrenHover(false);
        e.stopPropagation();
        return;
      }
      !isInsideNode2(e, tooltipRef) && setIsChildrenHover(false);
    };
    document.addEventListener("click", onClickLeave, true);
    return () => {
      document.removeEventListener("click", onClickLeave, true);
    };
  }, [shouldDetectOutsideClick, componentRef, tooltipRef]);
  useEffect7(() => {
    if (trigger === "hover" && isChildrenHover) {
      const timeoutId = setTimeout(
        () => {
          setIsChildrenHover(false);
        },
        isMobile ? TOOLTIP_TOUCH_DURATION : TOOLTIP_HOVER_MAX_DURATION
      );
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isMobile, trigger, isChildrenHover]);
  const [localOpen, setLocalOpen] = useState8(false);
  useEffect7(() => {
    setLocalOpen(open);
  }, [open]);
  if (trigger === "manual") {
    return {
      isOpen: localOpen,
      tooltipChildrenProps: {},
      tooltipContainerProps: props
    };
  }
  if (trigger === "click") {
    const isOpen = !disabled && isChildrenHover;
    const onClick = () => {
      if (!isOpen && !disabled) {
        startTransition(() => setIsChildrenHover(true));
      }
    };
    return {
      isOpen,
      tooltipChildrenProps: {
        onClick
      },
      tooltipContainerProps: props
    };
  }
  if (isMobile) {
    return {
      isOpen: !disabled && isChildrenHover,
      tooltipChildrenProps: longPressListeners,
      tooltipContainerProps: props
    };
  }
  return {
    isOpen: !disabled && (isChildrenHover || isTooltipHover),
    tooltipChildrenProps: {
      onMouseEnter: !disabled ? () => setIsChildrenHover(true) : void 0,
      onMouseLeave: !disabled ? () => setIsChildrenHover(false) : void 0
    },
    tooltipContainerProps: {
      ...props,
      onMouseEnter: !disabled ? () => setIsTooltipHover(true) : void 0,
      onMouseLeave: !disabled ? () => setIsTooltipHover(false) : void 0
    }
  };
};
var Tooltip = ({
  containerNode,
  position: positionFromProps = "top",
  withTail = false,
  content,
  children,
  className,
  style,
  margin = TOOLTIP_MARGIN,
  trigger = "hover",
  inverted = false,
  onShow = _18.noop,
  onHide = _18.noop,
  fixed = false,
  alignment: givenAlignment = "center",
  ...props
}) => {
  var _a;
  const [, startTransition] = useTransition2();
  const arrowRef = useRef4(null);
  const placement = `${positionFromProps}${givenAlignment === "center" ? "" : `-${givenAlignment}`}`;
  const { refs, floatingStyles, middlewareData, context } = useFloating2({
    strategy: fixed ? "fixed" : "absolute",
    whileElementsMounted: autoUpdate2,
    placement,
    middleware: [
      offset2(margin),
      inline(),
      flip2(),
      shift2({
        limiter: limitShift()
      }),
      size2({
        apply({ availableWidth, availableHeight, elements }) {
          elements.floating.style.setProperty("--tooltip-max-width", `${availableWidth}px`);
          elements.floating.style.setProperty("--tooltip-max-height", `${availableHeight}px`);
        }
      }),
      hide({ strategy: "referenceHidden" }),
      arrow({
        element: arrowRef,
        padding: 12
      })
    ]
  });
  const isEmpty = _18.isEmpty(content);
  const { isOpen, tooltipChildrenProps, tooltipContainerProps } = useTooltipOpening({
    trigger,
    tooltipRef: refs.floating,
    componentRef: refs.domReference,
    startTransition,
    ...props
  });
  useEffect7(() => {
    isOpen ? onShow() : onHide();
  }, [isOpen, onShow, onHide]);
  return /* @__PURE__ */ jsxs13("span", { className: src_components_atoms_Tooltip_default.span, children: [
    isValidElement(children) ? cloneElement(children, { ref: refs.setReference, ...tooltipChildrenProps }) : /* @__PURE__ */ jsx19("span", { ref: refs.setReference, ...tooltipChildrenProps, children }),
    isOpen && !isEmpty && /* @__PURE__ */ jsx19(Portal_default, { shouldDisableScroll: false, containerNode, children: /* @__PURE__ */ jsx19(
      "div",
      {
        className: cx17(KIT_PORTAL_ROOT_CLASSNAME, src_components_atoms_Tooltip_default.tooltipRoot),
        ref: refs.setFloating,
        style: { ...floatingStyles, "--k-z-tooltip": Z_TOOLTIP },
        "data-hidden": +(((_a = middlewareData.hide) == null ? void 0 : _a.referenceHidden) ?? 0),
        children: /* @__PURE__ */ jsxs13(
          "span",
          {
            style,
            tabIndex: -1,
            className: cx17(
              KIT_TOOLTIP_CLASSNAME,
              className,
              inverted && KIT_CLASSNAME_INVERTED_THEME,
              src_components_atoms_Tooltip_default.tooltipContainer
            ),
            ...tooltipContainerProps,
            children: [
              /* @__PURE__ */ jsx19(FloatingArrow, { ref: arrowRef, context, width: 6, height: 3, fill: "var(--tooltip-bg)" }),
              /* @__PURE__ */ jsx19("span", { className: src_components_atoms_Tooltip_default.tooltip, children: content })
            ]
          }
        )
      }
    ) })
  ] });
};
var Tooltip_default = Tooltip;

// src/primary/components/atoms/Tab.tsx
import { cx as cx18 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_primary_components_atoms_Tab.module.css
var src_primary_components_atoms_Tab_default = { "tabContent": "pkit-upftNq-tabContent", "outlineTab": "pkit-upftNq-outlineTab", "selectedArea": "pkit-upftNq-selectedArea", "tab": "pkit-upftNq-tab", "text": "pkit-upftNq-text" };

// src/primary/components/atoms/Tab.tsx
import { jsx as jsx20, jsxs as jsxs14 } from "react/jsx-runtime";
var Tab = React6.forwardRef(
  ({ children, active = false, tabIndex = 1, className, disabled, ...props }, ref) => {
    const [overlayColor, setOverlayColor] = useState9(active ? "black" : "blue");
    useEffect8(() => {
      const timeoutId = setTimeout(() => setOverlayColor(active ? "black" : "blue"), 500);
      return () => clearTimeout(timeoutId);
    }, [active]);
    return /* @__PURE__ */ jsx20(
      "div",
      {
        "data-active": +active,
        ref,
        tabIndex,
        className: cx18(KIT_TAB_CLASSNAME, className, src_primary_components_atoms_Tab_default.tab),
        style: {
          "--pk-tab-color": `var(${disabled ? "--pk-disabled-content-color" : active ? "--pk-text-white-color" : "--pk-text-blue-color"})`
        },
        ...props,
        children: /* @__PURE__ */ jsxs14(Overlay_default, { color: overlayColor, disabled, children: [
          active && /* @__PURE__ */ jsx20("div", { className: src_primary_components_atoms_Tab_default.selectedArea, children: /* @__PURE__ */ jsx20(
            "div",
            {
              className: src_primary_components_atoms_Tab_default.outlineTab,
              style: dashStyle({ radius: 18, color: "#FFFFFF", dashThickness: 1, dashGap: 4, dashLength: 4 })
            }
          ) }),
          /* @__PURE__ */ jsx20("div", { className: src_primary_components_atoms_Tab_default.tabContent, children: children ? disabled ? /* @__PURE__ */ jsx20(Tooltip_default, { content: "Bient\xF4t disponible", position: "bottom", children: /* @__PURE__ */ jsx20("div", { className: src_primary_components_atoms_Tab_default.text, children }) }) : /* @__PURE__ */ jsx20("div", { className: src_primary_components_atoms_Tab_default.text, children }) : null })
        ] })
      }
    );
  }
);
var Tab_default = Tab;

// src/primary/components/atoms/Tag.tsx
import { cx as cx19 } from "@lls/utils";
import React7 from "react";

// tmp_esbuild1736180047891/_src_primary_components_atoms_Tag.module.css
var src_primary_components_atoms_Tag_default = { "label": "pkit-P4tryW-label", "container": "pkit-P4tryW-container" };

// src/primary/components/atoms/Tag.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var Tag = React7.forwardRef(({ label, className, disabled = false, ...props }, ref) => {
  return /* @__PURE__ */ jsx21("div", { ref, "data-disabled": +disabled, className: cx19(className, src_primary_components_atoms_Tag_default.container), ...props, children: /* @__PURE__ */ jsx21("div", { "data-disabled": +disabled, className: src_primary_components_atoms_Tag_default.label, children: label }) });
});
var Tag_default = Tag;

// src/primary/constants/exposedClassNames.ts
var PRIMARY_KIT_ACCORDION_CLASSNAME = "pkit-accordion";
var PRIMARY_KIT_ACCORDION_ELEMENT_CLASSNAME = "pkit-accordion-element";

// src/primary/components/molecules/Accordion.tsx
import { cx as cx20 } from "@lls/utils";
import { useControlled as useControlled2, useResizeObserver } from "@lls/utils";
import { forwardRef, useEffect as useEffect9, useRef as useRef5, useState as useState10 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_molecules_Accordion.module.css
var src_primary_components_molecules_Accordion_default = { "category": "pkit-kk4MPa-category", "itemContainer": "pkit-kk4MPa-itemContainer", "categoryTitle": "pkit-kk4MPa-categoryTitle", "content": "pkit-kk4MPa-content", "accordionItemContainer": "pkit-kk4MPa-accordionItemContainer", "dash": "pkit-kk4MPa-dash", "accordionInnerItemContainer": "pkit-kk4MPa-accordionInnerItemContainer", "toggleIcon": "pkit-kk4MPa-toggleIcon" };

// src/primary/components/molecules/Accordion.tsx
import { jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
var AccordionContent = ({ category = "", isOpen, children, toggleOpen }) => {
  const [contentHeight, setContentHeight] = useState10(0);
  const [isTransited, setIstransited] = useState10(false);
  const contentRef = useRef5(null);
  useResizeObserver(useEffect9, {
    node: contentRef.current,
    onHeight: (height) => {
      setContentHeight((o) => Math.max(height, o));
    }
  });
  const onToggle = () => {
    setIstransited(true);
    toggleOpen();
  };
  const transitionStyle = {
    height: isOpen ? isTransited ? contentHeight : contentHeight === 0 ? "auto" : contentHeight : 0,
    overflow: "hidden",
    transition: "300ms"
  };
  return /* @__PURE__ */ jsxs15("div", { className: src_primary_components_molecules_Accordion_default.accordionInnerItemContainer, children: [
    /* @__PURE__ */ jsxs15("div", { className: src_primary_components_molecules_Accordion_default.category, onClick: onToggle, children: [
      /* @__PURE__ */ jsx22("div", { className: src_primary_components_molecules_Accordion_default.categoryTitle, children: category }),
      /* @__PURE__ */ jsx22(Button_default2, { theme: "white", iconLeft: isOpen ? "expandless" : "expandmore" })
    ] }),
    /* @__PURE__ */ jsx22("div", { className: src_primary_components_molecules_Accordion_default.content, style: transitionStyle, onTransitionEnd: () => setIstransited(false), children: /* @__PURE__ */ jsx22("div", { ref: contentRef, children }) })
  ] });
};
var Accordion = forwardRef(
  ({ className, children, openDefault = false, setIsOpen: setIsOpenFromProps, ...props }, ref) => {
    const [isOpen, setIsOpen] = useControlled2(openDefault, setIsOpenFromProps);
    const [disabled, setDisabled] = useState10(false);
    const toggleOpen = () => {
      isOpen ? setTimeout(() => setDisabled(!isOpen), 300) : setDisabled(!isOpen);
      setIsOpen(!isOpen);
    };
    useEffect9(() => {
      setDisabled(isOpen);
    }, [isOpen]);
    const contentAccordion = /* @__PURE__ */ jsx22(AccordionContent, { toggleOpen, isOpen, ...props, children });
    return /* @__PURE__ */ jsxs15(
      "div",
      {
        ref,
        className: cx20(PRIMARY_KIT_ACCORDION_CLASSNAME, className, src_primary_components_molecules_Accordion_default.accordionItemContainer),
        ...props,
        "data-is-open": +isOpen,
        onClick: isOpen ? void 0 : toggleOpen,
        children: [
          isOpen && /* @__PURE__ */ jsx22(
            "div",
            {
              className: src_primary_components_molecules_Accordion_default.dash,
              style: dashStyle({
                radius: 4,
                dashLength: 8,
                dashGap: 8,
                dashOffset: 2,
                dashThickness: 2,
                color: "#B3DAFF"
              })
            }
          ),
          /* @__PURE__ */ jsx22(Overlay_default, { color: "blue", disabled, children: contentAccordion })
        ]
      }
    );
  }
);
var Accordion_default = Accordion;

// src/primary/components/molecules/AccordionElement.tsx
import { cx as cx21 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_primary_components_molecules_AccordionElement.module.css
var src_primary_components_molecules_AccordionElement_default = { "mainPart": "pkit-3lpGmW-mainPart", "divider": "pkit-3lpGmW-divider", "buttonContainer": "pkit-3lpGmW-buttonContainer", "title": "pkit-3lpGmW-title", "itemContainer": "pkit-3lpGmW-itemContainer", "contentElement": "pkit-3lpGmW-contentElement" };

// src/primary/components/molecules/AccordionElement.tsx
import { jsx as jsx23, jsxs as jsxs16 } from "react/jsx-runtime";
var AccordionElement = ({
  className,
  icon,
  title,
  disabled = false,
  children,
  hasDivider = true,
  tagLabel
}) => {
  return /* @__PURE__ */ jsxs16("div", { className: cx21(PRIMARY_KIT_ACCORDION_ELEMENT_CLASSNAME, className, src_primary_components_molecules_AccordionElement_default.itemContainer), children: [
    /* @__PURE__ */ jsxs16("div", { className: src_primary_components_molecules_AccordionElement_default.contentElement, children: [
      /* @__PURE__ */ jsxs16("div", { className: src_primary_components_molecules_AccordionElement_default.mainPart, children: [
        icon && /* @__PURE__ */ jsx23(Icon_default, { color: disabled ? "var(--pk-disabled-content-color)" : "", name: icon }),
        /* @__PURE__ */ jsx23("div", { "data-disabled": +disabled, className: src_primary_components_molecules_AccordionElement_default.title, children: title }),
        !disabled && tagLabel && /* @__PURE__ */ jsx23(Tag_default, { disabled, label: tagLabel })
      ] }),
      disabled && tagLabel ? /* @__PURE__ */ jsx23(Tag_default, { disabled, label: tagLabel }) : /* @__PURE__ */ jsx23("div", { className: src_primary_components_molecules_AccordionElement_default.buttonContainer, children })
    ] }),
    hasDivider && /* @__PURE__ */ jsx23(Divider_default2, { className: src_primary_components_molecules_AccordionElement_default.divider })
  ] });
};
var AccordionElement_default = AccordionElement;

// src/primary/components/molecules/Card.tsx
import { cx as cx22 } from "@lls/utils";
import React8 from "react";

// tmp_esbuild1736180047891/_src_primary_components_molecules_Card.module.css
var src_primary_components_molecules_Card_default = { "cardInnerContent": "pkit-NpRWbW-cardInnerContent", "titleContainer": "pkit-NpRWbW-titleContainer", "cardContainer": "pkit-NpRWbW-cardContainer", "imgCard": "pkit-NpRWbW-imgCard", "title": "pkit-NpRWbW-title", "subtitle": "pkit-NpRWbW-subtitle" };

// src/primary/components/molecules/Card.tsx
import { jsx as jsx24, jsxs as jsxs17 } from "react/jsx-runtime";
var Card = React8.forwardRef(
  ({ srcImg, altImg, title, subtitle, className = "", classNameInner = "", ...props }, ref) => {
    return /* @__PURE__ */ jsx24(
      "div",
      {
        className: cx22(className, src_primary_components_molecules_Card_default.cardContainer),
        ...props,
        ref,
        children: /* @__PURE__ */ jsx24(Overlay_default, { color: "blue", children: /* @__PURE__ */ jsxs17("div", { className: cx22(classNameInner, src_primary_components_molecules_Card_default.cardInnerContent), children: [
          /* @__PURE__ */ jsx24("img", { className: src_primary_components_molecules_Card_default.imgCard, src: srcImg, alt: altImg }),
          /* @__PURE__ */ jsxs17("div", { className: src_primary_components_molecules_Card_default.titleContainer, children: [
            /* @__PURE__ */ jsx24("div", { className: src_primary_components_molecules_Card_default.title, children: title }),
            /* @__PURE__ */ jsx24("div", { className: src_primary_components_molecules_Card_default.subtitle, children: subtitle })
          ] })
        ] }) })
      }
    );
  }
);
var Card_default = Card;

// tmp_esbuild1736180047891/_src_primary_components_molecules_CheckBoxAccordion.module.css
var src_primary_components_molecules_CheckBoxAccordion_default = { "checkboxes": "pkit-fs1LzG-checkboxes", "sections": "pkit-fs1LzG-sections", "sectionContent": "pkit-fs1LzG-sectionContent", "checkbox": "pkit-fs1LzG-checkbox" };

// src/primary/components/molecules/CheckBoxAccordion.tsx
import { jsx as jsx25, jsxs as jsxs18 } from "react/jsx-runtime";
var CheckboxAccordion = ({
  sections,
  toggleSection,
  handleParentCheckboxChange,
  handleChildCheckboxChange
}) => {
  return /* @__PURE__ */ jsx25("div", { className: src_primary_components_molecules_CheckBoxAccordion_default.sections, children: sections == null ? void 0 : sections.map((section) => {
    var _a;
    return /* @__PURE__ */ jsxs18("div", { className: src_primary_components_molecules_CheckBoxAccordion_default.section, children: [
      /* @__PURE__ */ jsxs18("div", { className: src_primary_components_molecules_CheckBoxAccordion_default.sectionContent, children: [
        /* @__PURE__ */ jsx25(
          CheckBox_default,
          {
            className: src_primary_components_molecules_CheckBoxAccordion_default.checkbox,
            label: section.title,
            isChecked: section.allChecked,
            indeterminate: section.indeterminate,
            setIsChecked: () => handleParentCheckboxChange(section.id)
          }
        ),
        ((_a = section == null ? void 0 : section.checkboxes) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsx25(
          Button_default2,
          {
            theme: "floatingBlue",
            onClick: () => toggleSection(section.id),
            iconLeft: section.isOpen ? "remove" : "plus"
          }
        )
      ] }),
      section.isOpen && /* @__PURE__ */ jsx25("div", { className: src_primary_components_molecules_CheckBoxAccordion_default.checkboxes, children: section.checkboxes.map((checkbox) => /* @__PURE__ */ jsx25(
        CheckBox_default,
        {
          className: src_primary_components_molecules_CheckBoxAccordion_default.checkbox,
          label: checkbox.label,
          isChecked: checkbox.checked,
          setIsChecked: () => handleChildCheckboxChange(section.id, checkbox.id)
        },
        checkbox.id
      )) })
    ] }, section.id);
  }) });
};
var CheckBoxAccordion_default = CheckboxAccordion;

// src/primary/components/molecules/Confetti.tsx
import React9, { useRef as useRef6 } from "react";
import { Fragment as Fragment5, jsx as jsx26, jsxs as jsxs19 } from "react/jsx-runtime";
var CONFETTI_STAR_CONFIG = {
  spread: 360,
  ticks: 80,
  gravity: 0,
  decay: 0.92,
  startVelocity: 30,
  colors: ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"]
};
var shootStar = (confetti) => {
  const coord_x = Math.random() * 0.6 + 0.2;
  const coord_y = Math.random() * 0.6 + 0.2;
  confetti({
    ...CONFETTI_STAR_CONFIG,
    particleCount: 40,
    scalar: 1.2,
    origin: { x: coord_x, y: coord_y },
    shapes: ["star"],
    zIndex: Z_CONFETTI
  });
  confetti({
    ...CONFETTI_STAR_CONFIG,
    particleCount: 10,
    scalar: 0.75,
    origin: { x: coord_x, y: coord_y },
    shapes: ["circle"],
    zIndex: Z_CONFETTI
  });
};
var shoot = (confetti) => {
  setTimeout(() => shootStar(confetti), 0);
  setTimeout(() => shootStar(confetti), 100);
  setTimeout(() => shootStar(confetti), 200);
  setTimeout(() => shootStar(confetti), 1e3);
  setTimeout(() => shootStar(confetti), 1100);
  setTimeout(() => shootStar(confetti), 1200);
  setTimeout(() => shootStar(confetti), 2e3);
  setTimeout(() => shootStar(confetti), 2100);
  setTimeout(() => shootStar(confetti), 2200);
};
var schoolPride = (confetti) => {
  const end = Date.now() + 2 * 1e3;
  const colors = ["#FF669C", "#81C331", "#A788C2", "#4E98DF", "#FFB241"];
  const frame = (confetti2) => {
    confetti2({
      particleCount: 5,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors,
      zIndex: Z_CONFETTI
    });
    confetti2({
      particleCount: 5,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors,
      zIndex: Z_CONFETTI
    });
    if (Date.now() < end) {
      requestAnimationFrame(() => frame(confetti2));
    }
  };
  frame(confetti);
};
var Confetti = React9.forwardRef(
  ({ confettiTheme, onClick, ...props }, ref) => {
    const audioref = useRef6(null);
    return /* @__PURE__ */ jsxs19(Fragment5, { children: [
      /* @__PURE__ */ jsx26(Tooltip_default, { content: "C\xE9l\xE9bration", position: "bottom", margin: 5, children: /* @__PURE__ */ jsx26("div", { children: /* @__PURE__ */ jsx26(
        Button_default2,
        {
          theme: "white",
          iconLeft: "confetti",
          ref,
          onClick: async () => {
            var _a;
            onClick == null ? void 0 : onClick();
            const { default: confetti } = await import("canvas-confetti");
            schoolPride(confetti);
            shoot(confetti);
            (_a = audioref.current) == null ? void 0 : _a.play();
          },
          ...props
        }
      ) }) }),
      /* @__PURE__ */ jsx26("audio", { ref: audioref, children: /* @__PURE__ */ jsx26("source", { src: "assets/sound/mountain-victory2.mp3", type: "audio/mpeg" }) })
    ] });
  }
);
var Confetti_default = Confetti;

// src/primary/components/molecules/MenuButton/index.tsx
import { autoUpdate as autoUpdate3, flip as flip3, hide as hide2, limitShift as limitShift2, shift as shift3, size as size3, useFloating as useFloating3 } from "@floating-ui/react";
import { useControlled as useControlled3 } from "@lls/utils";
import _21 from "lodash/fp.js";
import React11, { useCallback as useCallback9 } from "react";

// src/primary/components/atoms/MenuItem.tsx
import _19 from "lodash/fp.js";
import { useCallback as useCallback7 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_atoms_MenuItem.module.css
var src_primary_components_atoms_MenuItem_default = { "dash": "pkit-bGH2RW-dash", "itemListContainer": "pkit-bGH2RW-itemListContainer", "menuItemContent": "pkit-bGH2RW-menuItemContent", "itemList": "pkit-bGH2RW-itemList", "menuItem": "pkit-bGH2RW-menuItem", "listMask": "pkit-bGH2RW-listMask" };

// src/primary/components/atoms/MenuItem.tsx
import { jsx as jsx27, jsxs as jsxs20 } from "react/jsx-runtime";
var MenuItemContent = ({ handleClick, disabled = false, icon, msg, ...props }) => {
  return /* @__PURE__ */ jsxs20("div", { ...props, className: src_primary_components_atoms_MenuItem_default.menuItem, onClick: handleClick, "data-disabled": +disabled, children: [
    icon && /* @__PURE__ */ jsx27(Icon_default, { name: icon, className: src_primary_components_atoms_MenuItem_default.icon }),
    /* @__PURE__ */ jsx27("span", { className: src_primary_components_atoms_MenuItem_default.menuItemContent, children: msg })
  ] });
};
var MenuItem2 = ({ onClick = _19.noop, onItemClick = _19.noop, msg, icon, disabled = false, ...props }) => {
  const handleClick = useCallback7(
    (event) => {
      event.stopPropagation();
      if (onClick) {
        onClick(event);
        onItemClick(event);
      }
    },
    [onClick, onItemClick]
  );
  const menuItemProps = {
    handleClick,
    icon,
    disabled,
    msg,
    ...props
  };
  return /* @__PURE__ */ jsx27(Overlay_default, { color: "blue", disabled, children: disabled ? /* @__PURE__ */ jsx27(Tooltip_default, { content: "Bient\xF4t disponible", position: "bottom", children: /* @__PURE__ */ jsx27("div", { children: /* @__PURE__ */ jsx27(MenuItemContent, { ...menuItemProps }) }) }) : /* @__PURE__ */ jsx27(MenuItemContent, { ...menuItemProps }) });
};
var MenuItem_default = MenuItem2;

// src/primary/components/molecules/MenuButton/ItemList.tsx
import { cx as cx23 } from "@lls/utils";
import _20 from "lodash/fp.js";
import React10, { useCallback as useCallback8 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_molecules_MenuButton_ItemList.module.css
var src_primary_components_molecules_MenuButton_ItemList_default = { "menuItemContent": "pkit-dwE_UW-menuItemContent", "listMask": "pkit-dwE_UW-listMask", "itemList": "pkit-dwE_UW-itemList", "itemListContainer": "pkit-dwE_UW-itemListContainer", "menuItem": "pkit-dwE_UW-menuItem", "dash": "pkit-dwE_UW-dash" };

// src/primary/components/molecules/MenuButton/ItemList.tsx
import { Fragment as Fragment6, jsx as jsx28, jsxs as jsxs21 } from "react/jsx-runtime";
var ItemList = React10.forwardRef(
  ({
    listItems,
    withMask = true,
    zIndex = "auto",
    onMaskClick = _20.noop,
    onItemClick = _20.noop,
    className,
    style,
    ...props
  }, ref) => {
    const onContainerClick = useCallback8((event) => {
      event.preventDefault();
      event.stopPropagation();
    }, []);
    return /* @__PURE__ */ jsxs21(Fragment6, { children: [
      withMask && /* @__PURE__ */ jsx28("div", { className: src_primary_components_molecules_MenuButton_ItemList_default.listMask, onClick: onMaskClick, style: { "--pk-z-mask": zIndex } }),
      /* @__PURE__ */ jsxs21(
        "div",
        {
          className: cx23(className, src_primary_components_molecules_MenuButton_ItemList_default.itemListContainer),
          style: {
            ...style,
            "--pk-z-buttons-list": zIndex
          },
          ...props,
          ref,
          onClick: onContainerClick,
          children: [
            /* @__PURE__ */ jsx28(
              "div",
              {
                className: src_primary_components_molecules_MenuButton_ItemList_default.dash,
                style: dashStyle({
                  radius: 8,
                  dashLength: 6,
                  dashGap: 8,
                  dashOffset: 2,
                  dashThickness: 2,
                  color: "#002E4D"
                })
              }
            ),
            /* @__PURE__ */ jsx28("div", { className: src_primary_components_molecules_MenuButton_ItemList_default.itemList, children: listItems == null ? void 0 : listItems.map((item, index) => /* @__PURE__ */ jsx28(MenuItem_default, { onItemClick, ...item }, index)) })
          ]
        }
      )
    ] });
  }
);
var ItemList_default = ItemList;

// src/primary/components/molecules/MenuButton/index.tsx
import { Fragment as Fragment7, jsx as jsx29, jsxs as jsxs22 } from "react/jsx-runtime";
var MenuButton = React11.forwardRef(
  ({
    listItems,
    fixed = false,
    onClick = _21.noop,
    theme = "blue",
    onOpenStateChange = _21.noop,
    isOpen: isOpenFromProps = false,
    setIsOpen: setIsOpenFromProps,
    className,
    ...props
  }, componentRef) => {
    const [isOpen, setIsOpen] = useControlled3(isOpenFromProps, setIsOpenFromProps);
    const toggleMenu = useCallback9(
      (event) => {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        setIsOpen((prevIsMenuOpen) => {
          onOpenStateChange(!prevIsMenuOpen);
          return !prevIsMenuOpen;
        });
      },
      [setIsOpen, onOpenStateChange]
    );
    const onClickCb = (event) => {
      toggleMenu(event);
      onClick(event);
    };
    const { refs, floatingStyles } = useFloating3({
      strategy: fixed ? "fixed" : "absolute",
      whileElementsMounted: autoUpdate3,
      placement: "bottom-start",
      middleware: [
        flip3(),
        shift3({
          limiter: limitShift2()
        }),
        size3({
          apply({ availableWidth, availableHeight, elements }) {
            var _a, _b;
            const elementRefWidth = (_b = (_a = elements.reference) == null ? void 0 : _a.getBoundingClientRect()) == null ? void 0 : _b.width;
            Object.assign(elements.floating.style, {
              maxWidth: `${availableWidth}px`,
              maxHeight: `${availableHeight}px`,
              minWidth: `${elementRefWidth}px`
            });
          }
        }),
        hide2({ strategy: "escaped" })
      ]
    });
    React11.useImperativeHandle(
      componentRef,
      () => refs.domReference.current
    );
    return /* @__PURE__ */ jsxs22(Fragment7, { children: [
      /* @__PURE__ */ jsx29(
        Button_default2,
        {
          iconRight: "arrowdropdown",
          onClick: onClickCb,
          theme,
          className,
          ...props,
          ref: refs.setReference
        }
      ),
      isOpen && /* @__PURE__ */ jsx29(Portal_default, { shouldDisableScroll: false, children: /* @__PURE__ */ jsx29(
        ItemList_default,
        {
          withMask: true,
          zIndex: Z_MENU_BUTTON,
          ref: refs.setFloating,
          style: floatingStyles,
          listItems,
          onItemClick: toggleMenu,
          onMaskClick: toggleMenu
        }
      ) })
    ] });
  }
);
var MenuButton_default = MenuButton;

// src/primary/components/molecules/Modal.tsx
import { cx as cx24 } from "@lls/utils";
import _22 from "lodash/fp.js";
import { useCallback as useCallback10, useEffect as useEffect10, useState as useState11 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_molecules_Modal.module.css
var src_primary_components_molecules_Modal_default = { "scrim": "pkit-BMgVpq-scrim", "modalTitle": "pkit-BMgVpq-modalTitle", "headerTitle": "pkit-BMgVpq-headerTitle", "container": "pkit-BMgVpq-container", "headerButtons": "pkit-BMgVpq-headerButtons", "modalContainer": "pkit-BMgVpq-modalContainer", "modalBody": "pkit-BMgVpq-modalBody", "modalHeader": "pkit-BMgVpq-modalHeader" };

// src/primary/components/molecules/Modal.tsx
import { Fragment as Fragment8, jsx as jsx30, jsxs as jsxs23 } from "react/jsx-runtime";
var Modal = ({
  title,
  fullwidth: fullWidth = false,
  fullheight: fullHeight = false,
  hasFullscreenButton = false,
  iconName,
  downloadProps = {},
  children,
  closeModal = _22.noop,
  shouldCloseModal,
  animationduration: animationDuration = 250,
  // ms
  className,
  isFullscreen = false,
  setIsFullscreen = _22.noop,
  disableEventListeners = false
}) => {
  const [isShown, setIsShown] = useState11("close");
  const [isRendered, setIsRendered] = useState11(true);
  const onCloseModal = useCallback10(async () => {
    if (shouldCloseModal && !await (shouldCloseModal == null ? void 0 : shouldCloseModal())) return;
    setIsShown("onlyChildren");
    setTimeout(() => {
      closeModal();
      setIsRendered(false);
      setIsShown("close");
    }, animationDuration);
  }, [animationDuration, closeModal, shouldCloseModal]);
  const onKeyDown = useCallback10(
    (event) => {
      const code = event.keyCode ? event.keyCode : event.which;
      if (isShown && code === KEY_CODE.ESCAPE) {
        event.stopPropagation();
        onCloseModal();
      }
    },
    [isShown, onCloseModal]
  );
  useEffect10(() => {
    if (disableEventListeners) return;
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [onKeyDown, disableEventListeners]);
  useEffect10(() => {
    const timeoutId = setTimeout(() => {
      setIsShown("open");
    }, 10);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };
  useEffect10(() => {
    const onFullscreenChange = () => {
      setIsFullscreen(Boolean(document.fullscreenElement));
    };
    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, [setIsFullscreen]);
  const { label: downloadLabel, ...componentProps } = downloadProps;
  return isRendered ? /* @__PURE__ */ jsx30(Portal_default, { className: cx24(KIT_MODAL_CLASSNAME, className), children: /* @__PURE__ */ jsxs23(
    "div",
    {
      className: src_primary_components_molecules_Modal_default.container,
      style: {
        "--pk-modal-animation-duration": `${animationDuration}ms`
      },
      children: [
        /* @__PURE__ */ jsx30(Scrim_default, { className: src_primary_components_molecules_Modal_default.scrim, "data-open": +(isShown === "open"), onClick: onCloseModal }),
        /* @__PURE__ */ jsxs23(
          "div",
          {
            className: src_primary_components_molecules_Modal_default.modalContainer,
            "data-fullheight": +fullHeight,
            "data-fullwidth": +fullWidth,
            "data-is-fullscreen": +isFullscreen,
            "data-open": +(isShown === "open"),
            children: [
              /* @__PURE__ */ jsxs23("div", { className: src_primary_components_molecules_Modal_default.modalHeader, "data-is-fullscreen": +isFullscreen, children: [
                /* @__PURE__ */ jsx30("div", { className: src_primary_components_molecules_Modal_default.headerTitle, children: !isFullscreen && /* @__PURE__ */ jsxs23(Fragment8, { children: [
                  iconName && /* @__PURE__ */ jsx30(Icon_default, { name: iconName, width: 24, height: 24 }),
                  /* @__PURE__ */ jsx30("div", { className: src_primary_components_molecules_Modal_default.modalTitle, children: title })
                ] }) }),
                /* @__PURE__ */ jsxs23("div", { className: src_primary_components_molecules_Modal_default.headerButtons, children: [
                  downloadLabel && /* @__PURE__ */ jsx30(Button_default2, { iconLeft: "download", theme: "floatingBlue", ...componentProps, children: downloadLabel }),
                  hasFullscreenButton && /* @__PURE__ */ jsx30(
                    Button_default2,
                    {
                      iconLeft: "fullscreen",
                      theme: isFullscreen ? "blue" : "floatingBlue",
                      onClick: toggleFullScreen
                    }
                  ),
                  /* @__PURE__ */ jsx30(Button_default2, { theme: isFullscreen ? "blue" : "floatingBlue", iconLeft: "cancel", onClick: onCloseModal })
                ] })
              ] }),
              /* @__PURE__ */ jsx30("div", { className: src_primary_components_molecules_Modal_default.modalBody, children: isShown !== "close" && children })
            ]
          }
        )
      ]
    }
  ) }) : null;
};
var Modal_default = Modal;

// src/primary/components/molecules/Tabs.tsx
import _23 from "lodash/fp.js";
import {
  Children,
  cloneElement as cloneElement2,
  forwardRef as forwardRef2,
  isValidElement as isValidElement2,
  useCallback as useCallback11,
  useEffect as useEffect11,
  useMemo as useMemo4,
  useRef as useRef7,
  useState as useState12
} from "react";
import { cx as cx25, useResizeObserver as useResizeObserver2 } from "@lls/utils";

// tmp_esbuild1736180047891/_src_primary_components_molecules_Tabs.module.css
var src_primary_components_molecules_Tabs_default = { "scrollableNode": "pkit-Qv2pNG-scrollableNode kit-scrollbarhidden", "outlineTab": "pkit-Qv2pNG-outlineTab", "tabs": "pkit-Qv2pNG-tabs", "container": "pkit-Qv2pNG-container", "selectedArea": "pkit-Qv2pNG-selectedArea" };

// src/primary/components/molecules/Tabs.tsx
import { jsx as jsx31, jsxs as jsxs24 } from "react/jsx-runtime";
var TRANSITION_DURATION = 300;
var scrollBy = (el, scrollValue) => {
  el.scrollBy({
    top: 0,
    left: scrollValue,
    behavior: "smooth"
  });
};
var Tabs = forwardRef2(
  ({ value, onChange = _23.noop, children, className, ...props }, ref) => {
    var _a, _b;
    const [scrollableNode, setScrollableNode] = useState12(null);
    const [needScrollUi, setNeedScrollUi] = useState12(false);
    const [init, setInit] = useState12(false);
    const contentRef = useRef7(null);
    const selectedTab = (_b = (_a = contentRef.current) == null ? void 0 : _a.children) == null ? void 0 : _b[value + 1];
    const selectedTabOffset = selectedTab == null ? void 0 : selectedTab.offsetLeft;
    const selectedTabWidth = selectedTab == null ? void 0 : selectedTab.clientWidth;
    const tabsChildren = useMemo4(() => {
      return Children.map(children, (child, i) => {
        const onChangeTabs = (i2, e) => {
          if (!scrollableNode) return;
          const { left: containerLeft = 0, width: containerWidth = 0 } = scrollableNode.getBoundingClientRect() || {};
          const { left: tabLeft = 0, width: tabWidth = 0 } = e.currentTarget.getBoundingClientRect() || {};
          const startOffset = tabLeft - containerLeft;
          const endOffset = containerLeft + containerWidth - (tabLeft + tabWidth);
          if (startOffset < 0) {
            scrollBy(scrollableNode, startOffset);
          } else if (endOffset < 0) {
            scrollBy(scrollableNode, -endOffset);
          }
          onChange(i2);
        };
        return isValidElement2(child) ? cloneElement2(child, {
          active: value === i,
          key: `tab-${i}`,
          tabIndex: i + 1,
          onClick: (e) => {
            const originalProps = child.props || {};
            if (originalProps.onClick) originalProps.onClick(e);
            if (!originalProps.disabled) onChangeTabs(i, e);
          }
        }) : null;
      });
    }, [children, value, onChange, scrollableNode]);
    const onWidthUpdated = useCallback11(() => {
      if (!scrollableNode) return;
      setNeedScrollUi(scrollableNode.clientWidth < scrollableNode.scrollWidth);
    }, [scrollableNode]);
    useResizeObserver2(useEffect11, {
      node: scrollableNode,
      onWidth: onWidthUpdated
    });
    const scrollLeft = () => {
      if (!scrollableNode) return;
      scrollBy(scrollableNode, -scrollableNode.getBoundingClientRect().width);
    };
    const scrollRight = () => {
      if (!scrollableNode) return;
      scrollBy(scrollableNode, scrollableNode.getBoundingClientRect().width);
    };
    const showDynamicOutline = !!selectedTabWidth;
    useEffect11(() => {
      if (!showDynamicOutline) return;
      const timeoutInit = setTimeout(() => {
        setInit(true);
      }, TRANSITION_DURATION + 100);
      return () => {
        clearTimeout(timeoutInit);
      };
    }, [showDynamicOutline]);
    return /* @__PURE__ */ jsxs24(
      "div",
      {
        className: cx25(KIT_TABS_CLASSNAME, className, src_primary_components_molecules_Tabs_default.container),
        ref,
        ...props,
        "data-is-scrollable": needScrollUi,
        children: [
          needScrollUi && /* @__PURE__ */ jsx31(
            Button_default2,
            {
              className: cx25(src_primary_components_molecules_Tabs_default.navigationButton, src_primary_components_molecules_Tabs_default.navigationButtonLeft),
              onClick: scrollLeft,
              theme: "white",
              children: /* @__PURE__ */ jsx31(Icon_default, { name: "carretleft", width: "10", height: "10" })
            }
          ),
          /* @__PURE__ */ jsx31("div", { ref: setScrollableNode, className: src_primary_components_molecules_Tabs_default.scrollableNode, children: /* @__PURE__ */ jsxs24("div", { className: src_primary_components_molecules_Tabs_default.tabs, "data-is-scrollable": needScrollUi, ref: contentRef, "data-init": +init, children: [
            /* @__PURE__ */ jsx31(
              "div",
              {
                className: src_primary_components_molecules_Tabs_default.selectedArea,
                style: {
                  "--pk-tab-index": value,
                  "--pk-tab-size": `${selectedTabWidth ?? 0}px`,
                  "--pk-tab-left": `${selectedTabOffset ?? 0}px`,
                  "--pk-tabs-transition-duration": `${TRANSITION_DURATION}ms`
                },
                children: /* @__PURE__ */ jsx31(
                  "div",
                  {
                    className: src_primary_components_molecules_Tabs_default.outlineTab,
                    style: dashStyle({ radius: 18, color: "#FFFFFF", dashThickness: 1, dashGap: 4, dashLength: 4 })
                  }
                )
              }
            ),
            tabsChildren
          ] }) }),
          needScrollUi && /* @__PURE__ */ jsx31(
            Button_default2,
            {
              className: cx25(src_primary_components_molecules_Tabs_default.navigationButton, src_primary_components_molecules_Tabs_default.navigationButtonRight),
              onClick: scrollRight,
              theme: "white",
              children: /* @__PURE__ */ jsx31(Icon_default, { name: "carretright", width: "10", height: "10" })
            }
          )
        ]
      }
    );
  }
);
var Tabs_default = Tabs;

// src/hooks/useAudio.tsx
import { useEffect as useEffect12, useRef as useRef8, useState as useState13 } from "react";
var useAudio = ({ src = "", defaultVolume, autoplay = false }) => {
  const refAudio = useRef8(typeof Audio !== "undefined" ? new Audio() : void 0);
  const [loop, setLoop] = useState13(false);
  const [isPlaying, setIsPlaying] = useState13(false);
  const [currentTime, setCurrentTime] = useState13(0);
  const [isReady, setIsReady] = useState13(false);
  const [hasError, setHasError] = useState13(false);
  const [volumeValue, setVolumeValue] = useState13(
    typeof defaultVolume !== "undefined" ? defaultVolume : refAudio.current ? refAudio.current.volume : 1
  );
  useEffect12(() => {
    setIsPlaying(false);
    setCurrentTime(0);
    if (refAudio.current) {
      refAudio.current.currentTime = 0;
      const href = typeof src === "string" ? src : URL.createObjectURL(src);
      refAudio.current.src = href;
      refAudio.current.preload = "metadata";
      refAudio.current.autoplay = autoplay;
    }
  }, [src, autoplay]);
  useEffect12(() => {
    if (refAudio.current) refAudio.current.loop = loop;
  }, [loop]);
  useEffect12(() => {
    const audioDom = refAudio.current;
    if (!audioDom) return;
    const onPlay = () => {
      setIsPlaying(true);
    };
    const onPause = () => {
      setIsPlaying(false);
    };
    const onLoadedMetadata = () => {
      setIsReady(true);
    };
    const onError = () => {
      setHasError(true);
    };
    const onEnded = () => {
      setCurrentTime(0);
    };
    const onTimeUpdate = () => {
      setCurrentTime(audioDom.currentTime);
    };
    const onVolumeChange = () => {
      setVolumeValue(audioDom.volume);
    };
    audioDom.addEventListener("play", onPlay);
    audioDom.addEventListener("pause", onPause);
    audioDom.addEventListener("loadedmetadata", onLoadedMetadata);
    audioDom.addEventListener("error", onError);
    audioDom.addEventListener("ended", onEnded);
    audioDom.addEventListener("stalled", onError);
    audioDom.addEventListener("timeupdate", onTimeUpdate);
    audioDom.addEventListener("volumechange", onVolumeChange);
    return () => {
      audioDom.removeEventListener("play", onPlay);
      audioDom.removeEventListener("pause", onPause);
      audioDom.removeEventListener("loadedmetadata", onLoadedMetadata);
      audioDom.removeEventListener("error", onError);
      audioDom.removeEventListener("ended", onEnded);
      audioDom.removeEventListener("stalled", onError);
      audioDom.removeEventListener("timeupdate", onTimeUpdate);
      audioDom.removeEventListener("volumechange", onVolumeChange);
      audioDom.pause();
      audioDom.currentTime = 0;
    };
  }, []);
  return {
    isReady,
    hasError,
    isPlaying,
    loop,
    volumeValue,
    value: currentTime,
    duration: refAudio.current ? refAudio.current.duration : 1,
    isNormalSpeed: refAudio.current ? refAudio.current.playbackRate === 1 : true,
    onRepeat: () => setLoop((o) => !o),
    onPause: () => {
      var _a;
      if (!isReady || hasError) return;
      (_a = refAudio.current) == null ? void 0 : _a.pause();
    },
    onPlay: () => {
      var _a;
      if (!isReady || hasError) return;
      (_a = refAudio.current) == null ? void 0 : _a.play();
    },
    onChangeValue: (newCurrentTime) => {
      if (refAudio.current) refAudio.current.currentTime = newCurrentTime;
    },
    onChangeVolume: (newVolume) => {
      if (refAudio.current) refAudio.current.volume = newVolume;
    },
    onChangeSpeed: (isNormalSpeed) => {
      if (refAudio.current) refAudio.current.playbackRate = isNormalSpeed ? 1 : 0.75;
    }
  };
};
var useAudio_default = useAudio;

// src/primary/components/atoms/Toggle.tsx
import { cx as cx26 } from "@lls/utils";
import _24 from "lodash/fp.js";
import React12, { useCallback as useCallback12, useEffect as useEffect13, useState as useState14 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_atoms_Toggle.module.css
var src_primary_components_atoms_Toggle_default = { "overlaySubContainer": "pkit-Wnedga-overlaySubContainer", "toggleIndicator": "pkit-Wnedga-toggleIndicator", "dashes": "pkit-Wnedga-dashes", "toggle": "pkit-Wnedga-toggle", "overlayContainer": "pkit-Wnedga-overlayContainer", "icon": "pkit-Wnedga-icon" };

// src/primary/components/atoms/Toggle.tsx
import { jsx as jsx32, jsxs as jsxs25 } from "react/jsx-runtime";
var ToggleButton = React12.forwardRef(
  ({
    value: valueFromProps = false,
    disabled = false,
    readonly = false,
    trueIcon = "heart",
    falseIcon = "camera",
    onChange = _24.noop,
    className,
    ...props
  }, ref) => {
    const [value, setValue] = useState14(valueFromProps);
    const [isHover, setIsHover] = useState14(false);
    const handleMouseEnter = () => setIsHover(true);
    const handleMouseLeave = () => setIsHover(false);
    const [isOverlayActive, setIsOverlayActive] = useState14(false);
    const handleMouseDown = () => setIsOverlayActive(true);
    const handleMouseUp = () => setIsOverlayActive(false);
    useEffect13(() => {
      setValue(valueFromProps);
    }, [valueFromProps]);
    const handleClick = useCallback12(
      (event) => {
        event.preventDefault();
        if (!disabled) {
          readonly ? onChange(value) : setValue((prevValue) => {
            const newValue = !prevValue;
            onChange(newValue);
            return newValue;
          });
        }
      },
      [disabled, onChange, value, readonly]
    );
    return /* @__PURE__ */ jsxs25(
      "div",
      {
        ref,
        onClick: handleClick,
        className: cx26(KIT_SWITCHBUTTON_CLASSNAME, className, src_primary_components_atoms_Toggle_default.toggle),
        "data-disabled": +disabled,
        "data-isactive": +value,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        ...props,
        children: [
          /* @__PURE__ */ jsx32("div", { className: src_primary_components_atoms_Toggle_default.toggleIndicator, "data-isactive": +value, children: /* @__PURE__ */ jsx32("div", { className: src_primary_components_atoms_Toggle_default.overlayContainer, children: /* @__PURE__ */ jsx32(Overlay_default, { color: "blue", isHover, isActive: isOverlayActive, children: /* @__PURE__ */ jsx32("div", { className: src_primary_components_atoms_Toggle_default.overlaySubContainer, children: /* @__PURE__ */ jsx32("div", { className: src_primary_components_atoms_Toggle_default.dashes, "data-isactive": +value }) }) }) }) }),
          /* @__PURE__ */ jsx32(Icon_default, { className: src_primary_components_atoms_Toggle_default.icon, "data-active": +!value, name: falseIcon, width: 24, height: 24 }),
          /* @__PURE__ */ jsx32(Icon_default, { className: src_primary_components_atoms_Toggle_default.icon, "data-active": +value, name: trueIcon, width: 24, height: 24 })
        ]
      }
    );
  }
);
var Toggle_default = ToggleButton;

// src/utils/video.tsx
var getTimeFromSecondes = (sec) => {
  if (!sec) return "00:00";
  const getFormated = (val) => `0${Math.floor(val)}`.slice(-2);
  if (sec >= 3600) return `${getFormated(sec / 3600)}:${getFormated(sec % 3600 / 60)}:${getFormated(sec % 60)}`;
  return `${getFormated(sec / 60)}:${getFormated(sec % 60)}`;
};

// src/primary/components/molecules/Player.tsx
import { cx as cx27 } from "@lls/utils";
import _25 from "lodash/fp.js";
import React13, { useState as useState15, useRef as useRef9 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_molecules_Player.module.css
var src_primary_components_molecules_Player_default = { "mainContainer": "pkit-1-7JAG-mainContainer", "volumeContainer": "pkit-1-7JAG-volumeContainer", "progressBarVolume": "pkit-1-7JAG-progressBarVolume", "timeDisplay": "pkit-1-7JAG-timeDisplay", "timeProgressBar": "pkit-1-7JAG-timeProgressBar", "duration": "pkit-1-7JAG-duration" };

// src/primary/components/molecules/Player.tsx
import { jsx as jsx33, jsxs as jsxs26 } from "react/jsx-runtime";
var PLAY_CONFIG = "play";
var DURATION_CONFIG = "duration";
var PROGRESSBAR_CONFIG = "progressbar";
var REPEAT_CONFIG = "repeat";
var FULLSCREEN_CONFIG = "fullscreen";
var VOLUME_CONFIG = "volume";
var SPEED_CONFIG = "speed";
var DEFAULT_CONFIG = [
  PLAY_CONFIG,
  DURATION_CONFIG,
  PROGRESSBAR_CONFIG,
  REPEAT_CONFIG,
  FULLSCREEN_CONFIG,
  VOLUME_CONFIG
];
var AUDIO_CONFIG = [PLAY_CONFIG, DURATION_CONFIG, PROGRESSBAR_CONFIG, REPEAT_CONFIG, VOLUME_CONFIG, SPEED_CONFIG];
var CONFIG_BY_THEME = {
  audio: AUDIO_CONFIG,
  video: DEFAULT_CONFIG
};
var getConfig = (config) => {
  return _25.isArray(config) ? config : CONFIG_BY_THEME[config];
};
var Player = React13.forwardRef(
  ({
    className,
    volumeValue,
    value,
    duration,
    loop,
    isPlaying,
    isFullscreen = false,
    onChangeValue,
    onChangeVolume,
    isNormalSpeed = false,
    onChangeSpeed,
    onPause,
    onPlay,
    onFullScreen = _25.noop,
    onRepeat,
    customConfig = DEFAULT_CONFIG,
    isReady,
    hasError,
    theme = "blue",
    ...props
  }, ref) => {
    const [isVolumeOpen, setVolumeOpen] = useState15(false);
    const timeOutIdRef = useRef9();
    const onMouseLeave = () => {
      if (isVolumeOpen) {
        timeOutIdRef.current = window.setTimeout(() => {
          setVolumeOpen(false);
        }, 1e3);
      }
    };
    const onMouseEnter = () => {
      timeOutIdRef.current && clearTimeout(timeOutIdRef.current);
      timeOutIdRef.current = void 0;
      setVolumeOpen(true);
    };
    const config = getConfig(customConfig);
    return /* @__PURE__ */ jsxs26("div", { className: cx27(KIT_PLAYER_CLASSNAME, className, src_primary_components_molecules_Player_default.mainContainer), ...props, ref, children: [
      config.includes(PLAY_CONFIG) && /* @__PURE__ */ jsx33(Tooltip_default, { content: isPlaying ? "Pause" : "Lecture", children: /* @__PURE__ */ jsx33("div", { children: /* @__PURE__ */ jsx33(
        Button_default2,
        {
          iconLeft: isPlaying ? "pause" : "playfilled",
          theme: theme === "blue" ? "floatingBlue" : "floatingWhite",
          onClick: isPlaying ? onPause : onPlay,
          disabled: !isReady || hasError
        }
      ) }) }),
      config.includes(DURATION_CONFIG) && /* @__PURE__ */ jsxs26("div", { className: src_primary_components_molecules_Player_default.timeDisplay, "data-theme": theme, children: [
        getTimeFromSecondes(value),
        " / ",
        getTimeFromSecondes(duration)
      ] }),
      config.includes(PROGRESSBAR_CONFIG) && /* @__PURE__ */ jsx33(
        ProgressBar_default,
        {
          className: src_primary_components_molecules_Player_default.timeProgressBar,
          value,
          min: 0,
          max: duration,
          step: 1,
          onChange: onChangeValue,
          width: "200px"
        }
      ),
      config.includes(REPEAT_CONFIG) && /* @__PURE__ */ jsx33(Tooltip_default, { content: "R\xE9p\xE9ter", children: /* @__PURE__ */ jsx33("div", { children: /* @__PURE__ */ jsx33(
        Button_default2,
        {
          iconLeft: loop ? "repeat" : "repeatoff",
          theme: theme === "blue" ? "floatingBlue" : "floatingWhite",
          onClick: onRepeat
        }
      ) }) }),
      config.includes(FULLSCREEN_CONFIG) && /* @__PURE__ */ jsx33(Tooltip_default, { content: "Plein \xE9cran", children: /* @__PURE__ */ jsx33("div", { children: /* @__PURE__ */ jsx33(
        Button_default2,
        {
          iconLeft: isFullscreen ? "fullscreenexit" : "fullscreennew",
          theme: theme === "blue" ? "floatingBlue" : "floatingWhite",
          onClick: onFullScreen
        }
      ) }) }),
      config.includes(VOLUME_CONFIG) && /* @__PURE__ */ jsxs26("div", { className: src_primary_components_molecules_Player_default.volumeContainer, onMouseEnter, onMouseLeave, children: [
        /* @__PURE__ */ jsx33(
          Button_default2,
          {
            iconLeft: volumeValue === 0 ? "volumemute" : volumeValue < 0.33 ? "volumedown" : "volume",
            theme: theme === "blue" ? "floatingBlue" : "floatingWhite",
            onClick: () => setVolumeOpen((old) => !old)
          }
        ),
        isVolumeOpen && /* @__PURE__ */ jsx33("div", { className: src_primary_components_molecules_Player_default.progressBarVolume, children: /* @__PURE__ */ jsx33(
          ProgressBar_default,
          {
            value: volumeValue,
            min: 0,
            max: 1,
            step: 0.01,
            onChange: onChangeVolume,
            width: "8px",
            height: "120px",
            vertical: true
          }
        ) })
      ] }),
      _25.includes(SPEED_CONFIG, config) && /* @__PURE__ */ jsx33(
        Tooltip_default,
        {
          content: isNormalSpeed ? "Normal" : "Ralenti",
          position: isNormalSpeed ? "bottom" : "top",
          alignment: isNormalSpeed ? "end" : "start",
          children: /* @__PURE__ */ jsx33(
            Toggle_default,
            {
              value: isNormalSpeed,
              onChange: onChangeSpeed,
              trueIcon: "recordvoiceoverfilled",
              falseIcon: "turtle"
            }
          )
        }
      )
    ] });
  }
);
var Player_default = Player;

// src/primary/components/organisms/PlayerAudio.tsx
import { cx as cx28 } from "@lls/utils";
import React14 from "react";

// tmp_esbuild1736180047891/_src_primary_components_organisms_PlayerAudio.module.css
var src_primary_components_organisms_PlayerAudio_default = { "playerWrapper": "pkit-jhINba-playerWrapper", "dash": "pkit-jhINba-dash" };

// src/primary/components/organisms/PlayerAudio.tsx
import { jsx as jsx34, jsxs as jsxs27 } from "react/jsx-runtime";
var PlayerAudio = React14.forwardRef(
  ({ className, src, defaultVolume, autoplay, ...props }, ref) => {
    const propsPlayer = useAudio_default({ src, defaultVolume, autoplay });
    return /* @__PURE__ */ jsxs27("div", { className: cx28(KIT_PLAYER_AUDIO_CLASSNAME, className, src_primary_components_organisms_PlayerAudio_default.playerWrapper), ref, ...props, children: [
      /* @__PURE__ */ jsx34(
        "div",
        {
          style: dashStyle({ radius: 32, dashLength: 8, dashGap: 8, dashOffset: 2, dashThickness: 2, color: "white" }),
          className: src_primary_components_organisms_PlayerAudio_default.dash
        }
      ),
      /* @__PURE__ */ jsx34(Player_default, { customConfig: "audio", ...propsPlayer })
    ] });
  }
);
var PlayerAudio_default = PlayerAudio;

// src/utils/circularProgressBar.tsx
var getProgress = ({ animationLaunched, progress }) => !animationLaunched ? 0 : progress;
var getProgressLength = ({
  animationLaunched,
  progressFromProps,
  steps,
  strokeLength
}) => {
  const progress = getProgress({ animationLaunched, progress: progressFromProps });
  return strokeLength / steps * (steps - progress);
};
var getStrokeLength = (radius) => 2 * Math.PI * radius;
var getStrokeWidth = ({ radius, strokeRatio }) => radius * strokeRatio;
var getWidth = ({ radius, strokeRatio }) => 2 * radius + getStrokeWidth({ radius, strokeRatio }) * 2;
var getPercentWidth = ({ radius, strokeWidth }) => radius * 2 - strokeWidth;
var getStrokeDashOffset = ({
  animationLaunched,
  inverse,
  progressFromProps,
  strokeLength,
  steps,
  variant
}) => {
  if (variant === "determinate") {
    const progressLength = getProgressLength({
      animationLaunched,
      progressFromProps,
      steps,
      strokeLength
    });
    if (inverse) {
      return progressLength - strokeLength;
    }
    return progressLength;
  }
  return strokeLength / 2;
};
var getStrokeDashArray = ({
  animationLaunched,
  inverse,
  progressFromProps,
  strokeLength,
  steps
}) => {
  if (inverse) {
    const progressLength = getProgressLength({
      animationLaunched,
      progressFromProps,
      steps,
      strokeLength
    });
    return [progressLength, strokeLength];
  }
  return [strokeLength, strokeLength];
};
var getTrackStrokeDashArray = ({ animationLaunched, strokeLength }) => {
  if (!animationLaunched) {
    return [0, strokeLength];
  }
  return [strokeLength, strokeLength];
};

// src/components/atoms/CircularProgressBar.tsx
import { cx as cx29 } from "@lls/utils";
import { useEffect as useEffect14, useMemo as useMemo5, useState as useState16 } from "react";

// tmp_esbuild1736180047891/_src_components_atoms_CircularProgressBar.module.css
var src_components_atoms_CircularProgressBar_default = { "circularProgressBarSvg": "pkit-V1DOSq-circularProgressBarSvg", "circularProgressBarProgress": "pkit-V1DOSq-circularProgressBarProgress", "circular-progress-bar-spin": "pkit-V1DOSq-circular-progress-bar-spin", "progressBarContainer": "pkit-V1DOSq-progressBarContainer", "circularProgressBarTrack": "pkit-V1DOSq-circularProgressBarTrack", "progressBarPercent": "pkit-V1DOSq-progressBarPercent" };

// src/components/atoms/CircularProgressBar.tsx
import { Fragment as Fragment9, jsx as jsx35, jsxs as jsxs28 } from "react/jsx-runtime";
var CircularProgressBar = ({
  radius = 50,
  progress = 0,
  steps = 100,
  icon,
  inverse = false,
  displayPercent = false,
  variant = "indeterminate",
  strokeRatio = 0.4,
  progressColor = "var(--primary-40-color)",
  bgColor = "var(--gray-20-color)",
  children,
  fontSize,
  className,
  ...props
}) => {
  const [animationLaunched, setAnimationLaunched] = useState16(false);
  const strokeLinecap = "round";
  const strokeWidth = getStrokeWidth({ radius, strokeRatio });
  const strokeLength = getStrokeLength(radius);
  const width = getWidth({ radius, strokeRatio });
  const percentWidth = getPercentWidth({ radius, strokeWidth });
  useEffect14(() => {
    if (!animationLaunched) {
      setAnimationLaunched(true);
    }
  }, [animationLaunched]);
  const strokeDashOffset = useMemo5(
    () => getStrokeDashOffset({
      animationLaunched,
      inverse,
      progressFromProps: progress,
      strokeLength,
      steps,
      variant
    }),
    [animationLaunched, inverse, progress, strokeLength, steps, variant]
  );
  const strokeDashArray = useMemo5(
    () => getStrokeDashArray({
      animationLaunched,
      inverse,
      progressFromProps: progress,
      strokeLength,
      steps
    }),
    [animationLaunched, inverse, progress, strokeLength, steps]
  );
  const trackStrokeDashArray = useMemo5(
    () => getTrackStrokeDashArray({ animationLaunched, strokeLength }),
    [animationLaunched, strokeLength]
  );
  return /* @__PURE__ */ jsxs28(
    "div",
    {
      style: { "--k-width": `${width}px` },
      className: cx29(KIT_CIRCULARPROGRESSBAR_CLASSNAME, className, src_components_atoms_CircularProgressBar_default.progressBarContainer),
      ...props,
      "data-variant": variant,
      children: [
        /* @__PURE__ */ jsxs28("svg", { width, height: width, viewBox: `0 0 ${width} ${width}`, className: src_components_atoms_CircularProgressBar_default.circularProgressBarSvg, children: [
          /* @__PURE__ */ jsx35(
            "circle",
            {
              cx: width / 2,
              cy: width / 2,
              r: radius,
              fill: "none",
              stroke: bgColor,
              strokeWidth,
              strokeDasharray: trackStrokeDashArray.toString(),
              strokeLinecap,
              className: src_components_atoms_CircularProgressBar_default.circularProgressBarTrack
            }
          ),
          /* @__PURE__ */ jsx35(
            "circle",
            {
              cx: width / 2,
              cy: width / 2,
              r: radius,
              fill: "none",
              stroke: progressColor,
              strokeWidth,
              strokeDasharray: strokeDashArray.toString(),
              strokeDashoffset: strokeDashOffset.toString(),
              strokeLinecap,
              className: src_components_atoms_CircularProgressBar_default.circularProgressBarProgress
            }
          )
        ] }),
        (displayPercent || icon) && /* @__PURE__ */ jsx35(
          "div",
          {
            className: src_components_atoms_CircularProgressBar_default.progressBarPercent,
            style: {
              "--k-width": `${percentWidth}px`,
              "--k-height": `${percentWidth}px`,
              "--k-fontSize": fontSize || `${percentWidth * 0.3}px`
            },
            children: icon ? /* @__PURE__ */ jsx35(Icon_default, { name: icon, width: percentWidth, height: percentWidth }) : /* @__PURE__ */ jsxs28(Fragment9, { children: [
              progress,
              "%"
            ] })
          }
        ),
        children || null
      ]
    }
  );
};
var CircularProgressBar_default = CircularProgressBar;

// src/components/molecules/Loader.tsx
import { cx as cx30 } from "@lls/utils";
import _26 from "lodash/fp.js";

// tmp_esbuild1736180047891/_src_components_molecules_Loader.module.css
var src_components_molecules_Loader_default = { "backdrop": "pkit-X7wdja-backdrop" };

// src/components/molecules/Loader.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var Loader = ({ onBackdropClick = _26.noop, className, style, ...props }) => /* @__PURE__ */ jsx36(
  "div",
  {
    className: cx30(className, src_components_molecules_Loader_default.backdrop),
    style: { ...style, "--k-z-backdrop": Z_BACKDROP },
    onClick: onBackdropClick,
    ...props,
    children: /* @__PURE__ */ jsx36(CircularProgressBar_default, { strokeRatio: 0.2, progressColor: "var(--gray-50-color)" })
  }
);
var Loader_default = Loader;

// src/hooks/useBuffering.tsx
import { useCallback as useCallback13, useState as useState17 } from "react";
var useBuffering = () => {
  const [buffering, setBuffering] = useState17(false);
  const makeBufferingEventToCallback = useCallback13(
    (currentVideo, { setIsReady }) => {
      let isWaitingForData = false;
      let userRequestedPlaying = false;
      let ignoreNextPauseEvent = false;
      const onCanplaythrough = () => {
        setIsReady(true);
        setBuffering(false);
        isWaitingForData = false;
        if (userRequestedPlaying) {
          currentVideo.play();
        }
      };
      const onWaiting = () => {
        isWaitingForData = true;
        ignoreNextPauseEvent = true;
        currentVideo.pause();
        setTimeout(() => {
          if (isWaitingForData) {
            setBuffering(true);
          }
        }, 300);
      };
      const onPlay = () => {
        userRequestedPlaying = true;
      };
      const onPause = () => {
        if (!ignoreNextPauseEvent) {
          userRequestedPlaying = false;
        }
        ignoreNextPauseEvent = false;
      };
      return {
        play: onPlay,
        pause: onPause,
        canplaythrough: onCanplaythrough,
        waiting: onWaiting
      };
    },
    []
  );
  return { buffering, makeBufferingEventToCallback };
};
var useBuffering_default = useBuffering;

// src/hooks/useVideoControls.tsx
import _27 from "lodash/fp.js";
import { useCallback as useCallback14, useEffect as useEffect15, useMemo as useMemo6, useState as useState18 } from "react";
var useVideoControls = (node) => {
  const [areControlsOpened, setAreControlsOpened] = useState18(false);
  const [areMouseOverController, setMouseOverController] = useState18(false);
  const hideControls = useCallback14(() => {
    setAreControlsOpened(false);
    areMouseOverController && setMouseOverController(false);
  }, [areMouseOverController]);
  const debouncedHideControls = useMemo6(() => _27.debounce(1e3, hideControls), [hideControls]);
  const showControls = useCallback14(() => {
    setAreControlsOpened(true);
    !areMouseOverController && debouncedHideControls();
  }, [debouncedHideControls, areMouseOverController]);
  const showControlsAndCancelDebounce = useCallback14(() => {
    debouncedHideControls.cancel();
    setMouseOverController(true);
    setAreControlsOpened(true);
  }, [debouncedHideControls]);
  useEffect15(() => {
    _27.noop(node);
    return () => {
      debouncedHideControls.cancel();
      debouncedHideControls.flush();
    };
  }, [debouncedHideControls, node]);
  return {
    areControlsOpened,
    showControls,
    showControlsAndCancelDebounce,
    debouncedHideControls
  };
};
var useVideoControls_default = useVideoControls;

// src/hooks/useVolume.tsx
import { useCallback as useCallback15, useState as useState19 } from "react";
var useVolume = (node, defaultVolume = 1) => {
  const [isMuted, setIsMuted] = useState19(false);
  const [volume, setVolume] = useState19(defaultVolume);
  const muteVideo = useCallback15(
    (muted) => {
      setVolume((oldVolume) => {
        const newVolume = oldVolume || 1;
        if (node) node.volume = muted ? 0 : newVolume;
        return newVolume;
      });
      setIsMuted(muted);
    },
    [node]
  );
  const changeVolume = useCallback15(
    (newVolume) => {
      if (node) node.volume = newVolume;
      setVolume(newVolume);
      setIsMuted(newVolume === 0);
    },
    [node]
  );
  return {
    volume,
    isMuted,
    muteVideo,
    changeVolume
  };
};
var useVolume_default = useVolume;

// src/primary/components/organisms/VideoPlayer.tsx
import { cx as cx31 } from "@lls/utils";
import _28 from "lodash/fp.js";
import { useCallback as useCallback16, useEffect as useEffect16, useRef as useRef10, useState as useState20 } from "react";

// tmp_esbuild1736180047891/_src_primary_components_organisms_VideoPlayer.module.css
var src_primary_components_organisms_VideoPlayer_default = { "error": "pkit-ff9oca-error", "loader": "pkit-ff9oca-loader", "video": "pkit-ff9oca-video", "icon": "pkit-ff9oca-icon", "poster": "pkit-ff9oca-poster", "playerWrapper": "pkit-ff9oca-playerWrapper", "dash": "pkit-ff9oca-dash", "container": "pkit-ff9oca-container", "controls": "pkit-ff9oca-controls" };

// src/primary/components/organisms/VideoPlayer.tsx
import { jsx as jsx37, jsxs as jsxs29 } from "react/jsx-runtime";
var VideoPlayer = ({ src, poster, onPlay, onPause, className, ...props }) => {
  const videoContainer = useRef10(null);
  const videoRef = useRef10(null);
  const [supportsVideo, setSupportsVideo] = useState20(true);
  const [controlsShown, setControlsShown] = useState20(false);
  const [progressMax, setProgressMax] = useState20(1);
  const [progressValue, setProgressValue] = useState20(0);
  const [isReady, setIsReady] = useState20(false);
  const [isPlaying, setIsPlaying] = useState20(false);
  const [loop, setLoop] = useState20(false);
  const { buffering, makeBufferingEventToCallback } = useBuffering_default();
  const onProgressClick = useCallback16((newProgress) => {
    if (videoRef.current) videoRef.current.currentTime = newProgress;
    setProgressValue(newProgress);
  }, []);
  const { areControlsOpened, showControls, showControlsAndCancelDebounce, debouncedHideControls } = useVideoControls_default(
    videoContainer.current
  );
  useEffect16(() => {
    if (!videoRef.current) return;
    const currentVideo = videoRef.current;
    currentVideo.onerror = () => setSupportsVideo(false);
    currentVideo.controls = false;
    setControlsShown(true);
    const onLoadedmetadata = () => {
      setIsReady(true);
      setProgressMax(currentVideo.duration);
    };
    const onTimeupdate = () => {
      if (progressMax === 0) onLoadedmetadata();
      setProgressValue(currentVideo.currentTime || 0);
    };
    const handlPause = () => {
      setIsPlaying(false);
      onPause == null ? void 0 : onPause();
    };
    const handlePlay = () => {
      setIsPlaying(true);
      onPlay == null ? void 0 : onPlay();
    };
    const handleEnd = () => {
      currentVideo.currentTime = 0;
      setIsPlaying(false);
    };
    const bufferingEventToCallback = makeBufferingEventToCallback(currentVideo, { setIsReady });
    currentVideo.addEventListener("loadedmetadata", onLoadedmetadata);
    currentVideo.addEventListener("timeupdate", onTimeupdate);
    currentVideo.addEventListener("pause", handlPause);
    currentVideo.addEventListener("play", handlePlay);
    currentVideo.addEventListener("ended", handleEnd);
    _28.forEach.convert({ cap: false })(
      (fn, eventName) => currentVideo.addEventListener(eventName, fn),
      bufferingEventToCallback
    );
    return () => {
      currentVideo.removeEventListener("loadedmetadata", onLoadedmetadata);
      currentVideo.removeEventListener("timeupdate", onTimeupdate);
      currentVideo.removeEventListener("pause", handlPause);
      currentVideo.removeEventListener("play", handlePlay);
      currentVideo.removeEventListener("ended", handleEnd);
      _28.forEach.convert({ cap: false })(
        (fn, eventName) => currentVideo.removeEventListener(eventName, fn),
        bufferingEventToCallback
      );
    };
  }, [progressMax, onPlay, onPause, makeBufferingEventToCallback]);
  const playPause = useCallback16(() => {
    if (!supportsVideo || !isReady || !videoRef.current) return;
    if (videoRef.current.paused || videoRef.current.ended) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  }, [supportsVideo, isReady]);
  const { volume, changeVolume } = useVolume_default(videoRef.current, 0.75);
  const [isFullscreen, setIsFullscreen] = useState20(false);
  useEffect16(() => {
    if (!document) return;
    const onFullscreenChange = () => {
      const fullScreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement;
      if (fullScreenElement === videoContainer.current) {
        setIsFullscreen(true);
      } else {
        setIsFullscreen(false);
      }
    };
    const pauseSpaceBar = (e) => {
      const vid = videoRef.current;
      if (!vid) return;
      if (e.code === "Space") {
        if (vid.paused) vid.play();
        else vid.pause();
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", pauseSpaceBar);
    document.addEventListener("fullscreenchange", onFullscreenChange);
    document.addEventListener("webkitfullscreenchange", onFullscreenChange);
    return () => {
      document.removeEventListener("keydown", pauseSpaceBar);
      document.removeEventListener("fullscreenchange", onFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", onFullscreenChange);
    };
  }, []);
  const toggleFullscreen = useCallback16(() => {
    if (!document || !videoContainer.current) return;
    if (!isFullscreen) {
      const requestFullScreen = videoContainer.current.requestFullscreen || videoContainer.current.mozRequestFullScreen || videoContainer.current.webkitRequestFullscreen || videoContainer.current.msRequestFullscreen;
      requestFullScreen.call(videoContainer.current);
    } else {
      const exitFullScreen = document.exitFullscreen || document.mozExitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
      exitFullScreen.call(document);
    }
  }, [isFullscreen]);
  const propsPlayer = {
    loop,
    isPlaying,
    volumeValue: volume,
    value: progressValue,
    isReady,
    hasError: false,
    customConfig: "video",
    duration: progressMax,
    isNormalSpeed: videoRef.current ? videoRef.current.playbackRate === 1 : true,
    theme: isFullscreen ? "white" : "blue",
    isFullscreen,
    onRepeat: () => setLoop((o) => !o),
    onFullScreen: toggleFullscreen,
    onPlay: playPause,
    onPause: playPause,
    onChangeVolume: changeVolume,
    onChangeValue: onProgressClick,
    onChangeSpeed: (isNormalSpeed) => {
      if (videoRef.current) videoRef.current.playbackRate = isNormalSpeed ? 1 : 0.75;
    }
  };
  return /* @__PURE__ */ jsxs29(
    "div",
    {
      className: cx31(KIT_PLAYER_VIDEO_CLASSNAME, className, src_primary_components_organisms_VideoPlayer_default.container),
      ref: videoContainer,
      "data-is-fullscreen": +isFullscreen,
      onMouseMove: _28.debounce.convert({ fixed: false })(200, showControls, {
        leading: true,
        trailing: false
      }),
      children: [
        /* @__PURE__ */ jsx37("div", { className: src_primary_components_organisms_VideoPlayer_default.poster, children: /* @__PURE__ */ jsx37(
          "video",
          {
            className: src_primary_components_organisms_VideoPlayer_default.video,
            src,
            ref: videoRef,
            controls: true,
            onClick: playPause,
            onDoubleClick: toggleFullscreen,
            loop,
            preload: "metadata",
            ...props
          }
        ) }),
        isReady && buffering && /* @__PURE__ */ jsx37(Loader_default, { className: src_primary_components_organisms_VideoPlayer_default.loader }),
        supportsVideo ? /* @__PURE__ */ jsx37(
          "div",
          {
            className: src_primary_components_organisms_VideoPlayer_default.controls,
            onMouseEnter: showControlsAndCancelDebounce,
            onMouseLeave: debouncedHideControls,
            "data-isopen": +areControlsOpened,
            "data-shown": +!!controlsShown,
            "data-is-fullscreen": +isFullscreen,
            children: /* @__PURE__ */ jsxs29("div", { className: src_primary_components_organisms_VideoPlayer_default.playerWrapper, "data-is-fullscreen": +isFullscreen, children: [
              !isFullscreen && /* @__PURE__ */ jsx37(
                "div",
                {
                  style: dashStyle({
                    radius: 32,
                    dashLength: 8,
                    dashGap: 8,
                    dashOffset: 2,
                    dashThickness: 2,
                    color: "white"
                  }),
                  className: src_primary_components_organisms_VideoPlayer_default.dash
                }
              ),
              /* @__PURE__ */ jsx37(Player_default, { customConfig: "video", ...propsPlayer })
            ] })
          }
        ) : /* @__PURE__ */ jsxs29(
          "div",
          {
            className: src_primary_components_organisms_VideoPlayer_default.controls,
            "data-isopen": +areControlsOpened,
            "data-shown": +!!controlsShown,
            "data-is-fullscreen": +isFullscreen,
            onMouseEnter: showControlsAndCancelDebounce,
            onMouseLeave: debouncedHideControls,
            children: [
              /* @__PURE__ */ jsx37(Icon_default, { className: src_primary_components_organisms_VideoPlayer_default.icon, name: "warning" }),
              /* @__PURE__ */ jsx37("p", { className: src_primary_components_organisms_VideoPlayer_default.error, children: "Oups... impossible de lire la vid\xE9o." })
            ]
          }
        )
      ]
    }
  );
};
var VideoPlayer_default = VideoPlayer;

// src/primary/hooks/useCheckBoxAccordion.ts
import { useCallback as useCallback17, useState as useState21 } from "react";
var useCheckboxAccordion = (initialSections) => {
  const [sections, setSections] = useState21(initialSections);
  const toggleSection = useCallback17((sectionId) => {
    setSections(
      (prevSections) => prevSections == null ? void 0 : prevSections.map((section) => section.id === sectionId ? { ...section, isOpen: !section.isOpen } : section)
    );
  }, []);
  const handleParentCheckboxChange = useCallback17((sectionId) => {
    setSections(
      (prevSections) => prevSections == null ? void 0 : prevSections.map((section) => {
        if (section.id === sectionId) {
          const newCheckedState = !section.allChecked;
          const updatedCheckboxes = section.checkboxes.map((cb) => ({
            ...cb,
            checked: newCheckedState
          }));
          return {
            ...section,
            checkboxes: updatedCheckboxes,
            allChecked: newCheckedState,
            indeterminate: false
          };
        }
        return section;
      })
    );
  }, []);
  const handleChildCheckboxChange = useCallback17((sectionId, checkboxId) => {
    setSections(
      (prevSections) => prevSections == null ? void 0 : prevSections.map((section) => {
        if (section.id === sectionId) {
          const updatedCheckboxes = section.checkboxes.map(
            (cb) => cb.id === checkboxId ? { ...cb, checked: !cb.checked } : cb
          );
          const allChecked = updatedCheckboxes.every((cb) => cb.checked);
          const indeterminate = !allChecked && updatedCheckboxes.some((cb) => cb.checked);
          return {
            ...section,
            checkboxes: updatedCheckboxes,
            allChecked,
            indeterminate
          };
        }
        return section;
      })
    );
  }, []);
  const selectedSections = sections == null ? void 0 : sections.filter((section) => section.allChecked || section.indeterminate);
  return {
    sections,
    selectedSections,
    toggleSection,
    handleParentCheckboxChange,
    handleChildCheckboxChange
  };
};
var useCheckBoxAccordion_default = useCheckboxAccordion;

// src/primary/constants/style.tsx
var FONTS = {
  LATO: "LatoWeb",
  LLS_MONTSERRAT: "LLSMontserrat",
  PALLY: "Pally",
  LUCIOLE: "Luciole"
};

// src/primary/components/quarks/Typography.tsx
var FontStyle = `
  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-Thin.ttf') format('truetype');
    font-weight: lighter;
  }
  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-ThinItalic.ttf') format('truetype');
    font-style: italic;
    font-weight: lighter;
  }

  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-Light.ttf') format('truetype');
    font-weight: 400;
  }
  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-LightItalic.ttf') format('truetype');
    font-style: italic;
    font-weight: 400;
  }

  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-Regular.ttf') format('truetype');
    font-weight: 500;
  }
  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-Italic.ttf') format('truetype');
    font-style: italic;
    font-weight: 500;
  }

  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-Medium.ttf') format('truetype');
    font-weight: 700;
  }
  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-MediumItalic.ttf') format('truetype');
    font-style: italic;
    font-weight: 700;
  }
  
  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-SemiBold.ttf') format('truetype');
    font-weight: 800;
  }
  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-SemiBoldItalic.ttf') format('truetype');
    font-style: italic;
    font-weight: 800;
  }

  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-Bold.ttf') format('truetype');
    font-weight: 900;
  }
  @font-face {
    font-family: ${FONTS.LLS_MONTSERRAT};
    src: url('/assets/fonts/LLS-Montserrat-BoldItalic.ttf') format('truetype');
    font-style: italic;
    font-weight: 900;
  }

  @font-face {
    font-family: ${FONTS.PALLY};
    src:
      url('/assets/fonts/Pally-Regular.woff2') format('woff2'),
      url('/assets/fonts/Pally-Regular.ttf') format('truetype');
    font-weight: regular;
  }

  @font-face {
    font-family: ${FONTS.PALLY};
    src:
      url('/assets/fonts/Pally-Bold.woff2') format('woff2'),
      url('/assets/fonts/Pally-Bold.ttf') format('truetype');
    font-weight: bold;
  }

  @font-face {
    font-family: ${FONTS.LATO};
    src:
      url('/assets/fonts/Lato-Regular.woff2') format('woff2'),
      url('/assets/fonts/Lato-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: ${FONTS.LATO};
    src:
      url('/assets/fonts/Lato-Italic.woff2') format('woff2'),
      url('/assets/fonts/Lato-Italic.ttf') format('truetype');
    font-style: italic;
  }


  @font-face {
    font-family: ${FONTS.LATO};
    src:
      url('/assets/fonts/Lato-Bold.woff2') format('woff2'),
      url('/assets/fonts/Lato-Bold.ttf') format('truetype');
    font-weight: 700;
  }


  @font-face {
    font-family: ${FONTS.LATO};
    src:
      url('/assets/fonts/Lato-BoldItalic.woff2') format('woff2'),
      url('/assets/fonts/Lato-BoldItalic.ttf') format('truetype');
    font-style: italic;
    font-weight: 700;
  }


  @font-face {
    font-family: ${FONTS.LATO};
    src:
      url('/assets/fonts/Lato-Heavy.woff2') format('woff2'),
      url('/assets/fonts/Lato-Heavy.ttf') format('truetype');
    font-weight: 800;
  }

  @font-face {
    font-family: ${FONTS.LATO};
    src:
      url('/assets/fonts/Lato-HeavyItalic.woff2') format('woff2'),
      url('/assets/fonts/Lato-HeavyItalic.ttf') format('truetype');
    font-style: italic;
    font-weight: 800;
  }

  @font-face {
    font-family: ${FONTS.LATO};
    src:
      url('/assets/fonts/Lato-Black.woff2') format('woff2'),
      url('/assets/fonts/Lato-Black.ttf') format('truetype');
    font-weight: 900;
  }

  @font-face {
    font-family: ${FONTS.LATO};
    src:
      url('/assets/fonts/Lato-BlackItalic.woff2') format('woff2'),
      url('/assets/fonts/Lato-BlackItalic.ttf') format('truetype');
    font-style: italic;
    font-weight: 900;
  }

  @font-face {
    font-family: ${FONTS.LUCIOLE};
    src: url('/assets/fonts/Luciole-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: ${FONTS.LUCIOLE};
    src: url('/assets/fonts/Luciole-Regular-Italic.ttf') format('truetype');
    font-style: italic;
  }
  
  @font-face {
    font-family: ${FONTS.LUCIOLE};
    src: url('/assets/fonts/Luciole-Bold.ttf') format('truetype');
    font-weight: 800;
  }
  @font-face {
    font-family: ${FONTS.LUCIOLE};
    src: url('/assets/fonts/Luciole-Bold-Italic.ttf') format('truetype');
    font-style: italic;
    font-weight: 800;
  }
`;
var PBody1 = `
  font-family: ${FONTS.LATO}, ${FONTS.LLS_MONTSERRAT}, Arial, Helvetica, sans-serif;
  font-size: 20px;
  line-height: calc(28 / 20);
`;
var PBody2 = `
  font-family: ${FONTS.LATO}, ${FONTS.LLS_MONTSERRAT}, Arial, Helvetica, sans-serif;
  font-size: 16px;
  line-height: calc(26 / 20);
`;
var PButton2 = `
  font-family: ${FONTS.LATO}, ${FONTS.LLS_MONTSERRAT}, Arial, Helvetica, sans-serif;
  font-weight: 800;
  font-size: 32px;
  line-height: calc(48 / 32);
`;
var PButton1 = `
  font-family: ${FONTS.LATO}, ${FONTS.LLS_MONTSERRAT}, Arial, Helvetica, sans-serif;
  font-weight: 800;
  font-size: 16px;
  line-height: calc(24 / 16);
`;
var PHeading3 = `
font-family: ${FONTS.LATO}, ${FONTS.LLS_MONTSERRAT}, Arial, Helvetica, sans-serif;
font-size: 28px;
line-height: calc(40 / 28);
`;
var PHeading3Pally = `
font-family: ${FONTS.PALLY}, ${FONTS.LLS_MONTSERRAT}, Arial, Helvetica, sans-serif;
font-size: 28px;
line-height: calc(40 / 28);
`;
var PHeading2 = `
  font-family: ${FONTS.PALLY}, ${FONTS.LLS_MONTSERRAT}, Arial, Helvetica, sans-serif;
  font-size: 32px;
  line-height: calc(52 / 32);
`;
var PHeading1 = `
  font-family: ${FONTS.LATO}, ${FONTS.LLS_MONTSERRAT}, Arial, Helvetica, sans-serif;
  font-weight: 800;
  font-size: 44px;
  line-height: calc(56 / 44);
`;
export {
  Accordion_default as Accordion,
  AccordionElement_default as AccordionElement,
  Button_default2 as Button,
  Card_default as Card,
  CheckBox_default as CheckBox,
  CheckBoxAccordion_default as CheckboxAccordion,
  Chip_default2 as Chip,
  ChipSelect_default as ChipSelect,
  Confetti_default as Confetti,
  Divider_default2 as Divider,
  Meli_default as Meli,
  MenuButton_default as MenuButton,
  Modal_default as Modal,
  Overlay_default as Overlay,
  PBody1,
  PBody2,
  PButton1,
  PButton2,
  PHeading1,
  PHeading2,
  PHeading3,
  PHeading3Pally,
  PlayerAudio_default as PlayerAudio,
  ProgressBar_default as ProgressBar,
  Scrim_default as Scrim,
  Tab_default as Tab,
  Tabs_default as Tabs,
  Tag_default as Tag,
  VideoPlayer_default as VideoPlayer,
  dashStyle,
  useCheckBoxAccordion_default as useCheckboxAccordion
};
